(function(){

// Convert hex to readable name
function ntHexToName(hex){
  var map={'#000000':'Black','#ffffff':'White','#ff0000':'Red','#ff4444':'Red',
    '#e84040':'Red','#3d2b1a':'Dark Espresso','#f2ece3':'Ivory White',
    '#5bb8e8':'Sky Blue','#e87c28':'Orange','#8cc820':'Lime Green',
    '#f0c820':'Yellow','#9860d8':'Purple','#e880a8':'Pink','#2a1a0e':'Espresso'};
  if(!hex)return'';
  var h=hex.toLowerCase().trim();
  if(map[h])return map[h];
  // Try to match theme colours by name
  var cols=typeof ntGetColors==='function'?ntGetColors():[];
  for(var i=0;i<cols.length;i++){if(cols[i].fc&&cols[i].fc.toLowerCase()===h)return cols[i].n||'';}
  return '';
}
// NukkadTales Slider Functions

// ── PROXY URLS ─────────────────────────────────────────
const PROXY_URL        = 'https://legendary-selkie-d0c7dd.netlify.app/.netlify/functions/nt-ai';
const SEARCH_PROXY_URL = 'https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-haiku';
const GEMINI_SUGG_URL  = 'https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-gemini';
const GPT_SUGG_URL     = 'https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-gpt';
const CATALOG_PROXY_URL= 'https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/anthropic';
const SHOPIFY_STORE = window.NT_SHOPIFY_STORE||'';
const MODEL_SUGG       = 'claude-haiku-4-5-20251001';
const MODEL_LAYOUT     = 'claude-haiku-4-5-20251001';

// ── PRICING MATRIX ─────────────────────────────────────
const NT_PRICE_MAP = {
  "8-1":1299,"8-2":1299,"8-3":1399,"8-4":1499,
  "9-1":1499,"9-2":1499,"9-3":1599,"9-4":1699,
  "10-1":1699,"10-2":1699,"10-3":1899,"10-4":1999,
  "11-1":1999,"11-2":1999,"11-3":2199,"11-4":2299,
  "12-1":2299,"12-2":2299,"12-3":2699,"12-4":2799,
  "13-1":2799,"13-2":2799,"13-3":3199,"13-4":3299,
  "14-1":3299,"14-2":3299,"14-3":3799,"14-4":3899,
  "15-1":3899,"15-2":3899,"15-3":4399,"15-4":4499,
  "16-1":4499,"16-2":4499,"16-3":5099,"16-4":5199,
  "17-1":5199,"17-2":5199,"17-3":5799,"17-4":5899,
  "18-1":5899,"18-2":5899,"18-3":6599,"18-4":6699,
  "19-1":6699,"19-2":6699,"19-3":7399,"19-4":7499,
  "20-1":7499,"20-2":7499,"20-3":8399,"20-4":8499,
  "21-1":8499,"21-2":8499,"21-3":9399,"21-4":9499,
  "22-1":9499,"22-2":9499,"22-3":10499,"22-4":10599,
  "23-1":10599,"23-2":10599,"23-3":11599,"23-4":11699,
  "24-1":11699,"24-2":11699,"24-3":12799,"24-4":12899
};
function ntGetPrice(inch,lineCount){
  var key=Math.min(Math.max(inch,8),24)+'-'+Math.min(Math.max(lineCount,1),4);
  return NT_PRICE_MAP[key]||1299;
}
function ntGetVariantId(inch,lineCount){
  var key=Math.min(Math.max(inch,8),24)+'-'+Math.min(Math.max(lineCount,1),4);
  return (window.NT_VARIANT_MAP||{})[key]||null;
}

// NT_CUSTOM_ICONS is set by nukkad-customiser-section.liquid
window.NT_CUSTOM_ICONS = window.NT_CUSTOM_ICONS || [];

// NT_VARIANT_MAP is set by nukkad-slider.liquid inline script

// ── CONFIG ──────────────────────────────────────────────
window.NUKKAD_CONFIG = window.NUKKAD_CONFIG || {
  findQuoteClass: '.nt-ig-wrap',
  sliderHeading:  'What do you want to customise?',
  sliderSubtext:  'A name · a tagline · nameplate · etc. Type it below.',
  inputHint:      'Personalisation starts at ₹1,299',
  trustLine:      '4.9★ · 1,860 Google reviews · Ships in 3 days',
  trustPrice:     'Personalisation from ₹1,299',
};
var NUKKAD_CONFIG = window.NUKKAD_CONFIG;

// ── APPLY CONFIG TO FIRST SCREEN ───────────────────────
(function(){
  function applySliderText(){
    var cfg = window.NUKKAD_CONFIG || {};
    var h = document.getElementById('ntSlHeading'); if(h && cfg.sliderHeading) h.textContent = cfg.sliderHeading;
    var s = document.getElementById('ntSlSubtext'); if(s && cfg.sliderSubtext) s.textContent = cfg.sliderSubtext;
    // inputHint is set in HTML — do not override from config
    var inp = document.getElementById('ntSlInp'); if(inp && cfg.inputPlaceholder) inp.placeholder = cfg.inputPlaceholder;
    var tl = document.getElementById('ntSlTrustLine');
    if(tl && (cfg.trustLine || cfg.trustPrice)){
      var line = cfg.trustLine || '4.9★ · 1,860 Google reviews · Ships in 3 days';
      var price = cfg.trustPrice || 'Personalisation from ₹1,299';
      tl.innerHTML = line + ' · <span style="color:var(--orange);font-weight:700;">' + price + '</span>';
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applySliderText);
  else applySliderText();
  // Also re-apply after customiser section sets config
  setTimeout(applySliderText, 500);

// expose to window
window._ntTutInit=_ntTutInit;
window._ntTutToEmbed=_ntTutToEmbed;
window.goToEditorScreen=goToEditorScreen;
window.goToSearchScreen=goToSearchScreen;
window.ntAddToCart=ntAddToCart;
window.ntApplyBottomSection=ntApplyBottomSection;
window.ntApplyConfigTexts=ntApplyConfigTexts;
window.ntAutoSave=ntAutoSave;
window.ntBuildReviewsCarousel=ntBuildReviewsCarousel;
window.ntClearAllDesigns=ntClearAllDesigns;
window.ntCloseIconLetter=ntCloseIconLetter;
window.ntClosePolicy=ntClosePolicy;
window.ntCloseSizeGuideModal=ntCloseSizeGuideModal;
window.ntCloseSlider=ntCloseSlider;
window.ntCollapseEditBar=ntCollapseEditBar;
window.ntCommissionMantra=ntCommissionMantra;
window.ntCommissionPersonal=ntCommissionPersonal;
window.ntCommissionQuote=ntCommissionQuote;
window.ntDeleteDesign=ntDeleteDesign;
window.ntDesignIt=ntDesignIt;
window.ntDismissNavHelper=ntDismissNavHelper;
window.ntEditSaved=ntEditSaved;
window.ntExpandEditBar=ntExpandEditBar;
window.ntFillAndDesign=ntFillAndDesign;
window.ntGetPrice=ntGetPrice;
window.ntGetVariantId=ntGetVariantId;
window.ntILShowFloat=ntILShowFloat;
window.ntInitArtisan=ntInitArtisan;
window.ntInitCarousel=ntInitCarousel;
window.ntInitReviewScroll=ntInitReviewScroll;
window.ntInitVideoReviews=ntInitVideoReviews;
window.ntInjectCartProps=ntInjectCartProps;
window.ntLoadDesigns=ntLoadDesigns;
window.ntLoadReviews=ntLoadReviews;
window.ntOpenBrandLogo=ntOpenBrandLogo;
window.ntOpenCartFromBar=ntOpenCartFromBar;
window.ntOpenIconLetter=ntOpenIconLetter;
window.ntOpenPolicy=ntOpenPolicy;
window.ntOpenSizeGuide=ntOpenSizeGuide;
window.ntOpenSizeGuideModal=ntOpenSizeGuideModal;
window.ntOpenSlider=ntOpenSlider;
window.ntPlayVideoS4=ntPlayVideoS4;
window.ntPlayVideoV=ntPlayVideoV;
window.ntRefreshIconLetterRow=ntRefreshIconLetterRow;
window.ntRefreshSavedDesigns=ntRefreshSavedDesigns;
window.ntRemoveLetterIcon=ntRemoveLetterIcon;
window.ntSGOpenLightbox=ntSGOpenLightbox;
window.ntSaveDesign=ntSaveDesign;
window.ntScalePiece=ntScalePiece;
window.ntScrollToFind=ntScrollToFind;
window.ntShowInputForm=ntShowInputForm;
window.ntShowWelcomeBack=ntShowWelcomeBack;
window.ntToggleFaq=ntToggleFaq;
window.ntTutClose=ntTutClose;
window.ntTutDismiss=ntTutDismiss;
window.ntTutHideBubble=ntTutHideBubble;
window.ntTutMinimise=ntTutMinimise;
window.ntTutOpen=ntTutOpen;
window.ntTutShowBubble=ntTutShowBubble;
window.ntUpdateCartBtn=ntUpdateCartBtn;
window.ntUpdateDesign=ntUpdateDesign;
window.ntUpdatePersonalBtn=ntUpdatePersonalBtn;
window.ntWelcomeEdit=ntWelcomeEdit;
window.ntWelcomeStartFresh=ntWelcomeStartFresh;

})();

// ── OPEN / CLOSE ───────────────────────────────────────
function ntOpenSlider(tab){
  setTimeout(ntApplyConfigTexts,50);
  setTimeout(ntApplyConfigTexts,800); // second pass after chip editor renders
  // Re-inject gallery in case Lookify populated it after initial load
  setTimeout(function(){
    if(typeof injectGallery==='function')try{injectGallery();}catch(e){}
    else{
      var galSc=document.querySelector('.nt-slider-gallery-sc');
      var galDest=document.getElementById('ntSlGalleryContent');
      if(galSc&&galDest&&galSc.innerHTML.trim())galDest.innerHTML=galSc.innerHTML;
    }
  },800);
  // Re-trigger Lookify/gallery embed scripts after slider opens
  setTimeout(function(){

  },600);
  // If customise landing URL is set, redirect there — but NOT if coming from edit/skip
  var _landingUrl=window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.customiseLandingUrl;
  var _skipWelcome=sessionStorage.getItem('nt_skip_welcome');
  var _landingText=sessionStorage.getItem('nt_landing_text');
  // Only redirect if landing URL set and not already on that page
  if(_landingUrl&&tab==='customise'&&!_skipWelcome&&!_landingText){
    try{
      var _landingPath=(new URL(_landingUrl,window.location.href)).pathname;
      if(window.location.pathname!==_landingPath){window.location.href=_landingUrl;return;}
    }catch(e){window.location.href=_landingUrl;return;}
  }
  document.getElementById('ntBd').classList.add('show');
  var sl=document.getElementById('ntSl');sl.classList.add('open');sl.classList.remove('compact');

  // ── Welcome back screen — if saved designs exist and no landing text ──
  var landingText=sessionStorage.getItem('nt_landing_text');
  var _designs=ntLoadDesigns().filter(function(d){return d.lines&&d.lines.length;});
  var _skipWelcome=sessionStorage.getItem('nt_skip_welcome');
  sessionStorage.removeItem('nt_skip_welcome');

  /* ── Back-to-Ask-Gul bar: shown only when opened from a "Made for you" quote ── */
  var _fromAskGul=sessionStorage.getItem('nt_ask_gul_origin');
  sessionStorage.removeItem('nt_ask_gul_origin');
  var _backBar=document.getElementById('ntAskGulBack');
  if(_fromAskGul){
    if(!_backBar){
      _backBar=document.createElement('div');
      _backBar.id='ntAskGulBack';
      _backBar.style.cssText='display:flex;align-items:center;gap:7px;padding:10px 16px;'
        +'background:var(--cream,#f5ede0);border-bottom:1.5px solid var(--border,#e8d8c4);'
        +'cursor:pointer;font-size:11px;font-weight:700;color:var(--orange,#c85a1a);'
        +'font-family:"DM Sans",sans-serif;flex-shrink:0;-webkit-tap-highlight-color:transparent;'
        +'position:relative;z-index:101;';
      _backBar.innerHTML='&#8592; back to search results';
      _backBar.onclick=function(){
        ntCloseSlider();
        setTimeout(function(){
          if(typeof window.agReopen==='function') window.agReopen();
          else if(typeof window.ntAgOpen==='function') window.ntAgOpen();
        },200);
      };
      /* insert inside .nt-screen so it sits above the compact bar */
      var _ntScreen=document.querySelector('#ntScreens .nt-screen');
      if(_ntScreen) _ntScreen.insertBefore(_backBar,_ntScreen.firstChild);
      else{var _ntScreens=document.getElementById('ntScreens');if(_ntScreens)_ntScreens.insertBefore(_backBar,_ntScreens.firstChild);}
    }
    _backBar.style.display='flex';
  } else if(_backBar){
    _backBar.style.display='none';
  }

  if(!landingText&&!_skipWelcome&&_designs.length){
    // Show welcome screen
    ntShowWelcomeBack(_designs);
    return;
  }

  // Pre-fill from landing page input — skip input screen, go straight to chip editor
  if(landingText){
    sessionStorage.removeItem('nt_landing_text');
    // Hide the input form immediately so user never sees the text-entry step
    var _fb=document.getElementById('ntFormBar');
    if(_fb){_fb.classList.add('nt-hidden');_fb.style.setProperty('display','none','important');}
    var inp=document.getElementById('ntSlInp');
    if(inp) inp.value=landingText; // set value silently (no focus = no visible input)
    // Give chip editor JS time to load, then render directly
    setTimeout(function(){
      if(typeof ntDesignIt==='function' && landingText.trim()) ntDesignIt();
    },300);
  } else {
    setTimeout(function(){var inp=document.getElementById('ntSlInp');if(inp)inp.focus();},300);
  }
  setTimeout(ntInitVideoReviews,500);
  ntRefreshSavedDesigns();
}

// Hook auto-save — called from chip editor after renders
window.ntAutoSaveHook=function(){
  if(typeof ntAutoSave==='function')ntAutoSave();
  // Apply config every render — ensures designer toggle + cart msg update
  ntApplyConfigTexts();
  if(typeof ntTutShowBubble==='function')setTimeout(ntTutShowBubble,500);
};

function ntShowWelcomeBack(designs){
  var screens=document.getElementById('ntScreens');
  if(!screens)return;

  // Create welcome screen overlay
  var wb=document.createElement('div');
  wb.id='ntWelcomeBack';
  wb.style.cssText='position:absolute;inset:0;background:var(--cream,#f5ede0);z-index:200;overflow-y:auto;padding:24px 16px 32px;box-sizing:border-box;';

  var html='<div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:20px;">'
    +'<div>'
    +'<div style="font-family:\'Poppins\',sans-serif;font-weight:900;font-size:18px;color:#3d2b1a;letter-spacing:-0.02em;margin-bottom:4px;">Welcome back</div>'
    +'<div style="font-size:12px;color:#8c7b6e;">Continue where you left off, or start fresh.</div>'
    +'</div>'
    +'<button onclick="ntCloseSlider()" style="background:rgba(61,43,26,0.08);border:none;border-radius:50%;width:32px;height:32px;font-size:15px;color:#3d2b1a;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;line-height:1;">✕</button>'
    +'</div>';

  // Saved design cards
  html+='<div style="margin-bottom:16px;">';
  designs.slice(0,5).forEach(function(d){
    var label=d.lines.filter(function(l){return l&&!/^[·\-–—]+$/.test(l.trim());}).join(' · ');
    var price=d.intent==='personal'?'₹1,299':'₹999';
    var badge=d.commissioned?'<span style="font-size:9px;font-weight:700;color:#2d7d46;background:#e8f5ec;border-radius:20px;padding:2px 7px;margin-left:6px;">Ordered ✓</span>':'';
    html+='<div style="background:#fff;border:1.5px solid #e8d5c0;border-radius:12px;padding:12px 14px;margin-bottom:8px;display:flex;align-items:center;gap:12px;">'
      +'<div style="flex:1;min-width:0;">'
        +'<div style="font-family:\'Poppins\',sans-serif;font-weight:700;font-size:13px;color:#3d2b1a;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+label+badge+'</div>'
        +'<div style="font-size:10px;color:#8c7b6e;margin-top:2px;">'+d.date+' · '+d.inch+'" · '+price+'</div>'
      +'</div>'
      +'<button onclick="ntWelcomeEdit(\''+d.session+'\')" style="background:#c47a45;color:#fff;border:none;border-radius:20px;padding:7px 16px;font-size:11px;font-weight:700;cursor:pointer;font-family:\'DM Sans\',sans-serif;white-space:nowrap;flex-shrink:0;">Edit →</button>'
      +'</div>';
  });
  html+='</div>';

  // Start fresh button
  html+='<button onclick="ntWelcomeStartFresh()" style="width:100%;background:transparent;border:1.5px solid #c8b09a;border-radius:12px;padding:13px;font-size:13px;font-weight:700;color:#3d2b1a;cursor:pointer;font-family:\'DM Sans\',sans-serif;">+ Start a new design</button>';

  wb.innerHTML=html;
  // Append inside ntScreens so it sits within the scroll container
  var screens2=document.getElementById('ntScreens');
  if(screens2)screens2.appendChild(wb);
  else document.getElementById('ntSl').appendChild(wb);
}

function ntWelcomeEdit(session){
  // Remove welcome screen immediately, hide form, show editor shell — no blink
  var wb=document.getElementById('ntWelcomeBack');if(wb)wb.remove();
  var _fb=document.getElementById('ntFormBar');
  if(_fb){_fb.classList.add('nt-hidden');_fb.style.setProperty('display','none','important');}
  var _s1b=document.getElementById('ntS1Body');
  if(_s1b){_s1b.style.display='flex';_s1b.style.flex='1';_s1b.style.minHeight='0';}
  var _cb=document.getElementById('ntCompactBar');if(_cb)_cb.style.display='flex';
  // Find design and open editor
  var designs=ntLoadDesigns();
  var d=designs.find(function(x){return x.session===session;});
  if(!d)return;
  // Trigger edit
  setTimeout(function(){
    // Find index in designs array and call ntEditSaved with index
    var _designs=ntLoadDesigns();
    var _idx=_designs.findIndex(function(x){return x.session===d.session;});
    if(_idx>=0&&typeof ntEditSaved==='function')ntEditSaved(_idx);
    else if(typeof goRender==='function')goRender(d.lines,d.intent==='personal'?1299:999);
  },100);
}

function ntWelcomeStartFresh(){
  // Remove welcome screen and go to search
  var wb=document.getElementById('ntWelcomeBack');if(wb)wb.remove();
  setTimeout(function(){
    var inp=document.getElementById('ntSlInp');if(inp)inp.focus();
    ntRefreshSavedDesigns();
  },100);
}
function ntCloseSlider(){
  if(typeof ntTutHideBubble==='function')ntTutHideBubble();
  if(typeof ntTutClose==='function')ntTutClose();
  if(typeof ntFloatBarHide==='function')ntFloatBarHide();
  document.getElementById('ntBd').classList.remove('show');
  document.getElementById('ntSl').classList.remove('open');
  var fb=document.getElementById('ntFormBar');
  if(fb){fb.classList.remove('nt-hidden');fb.style.cssText='display:flex;flex-direction:column;flex:1;min-height:0;background:var(--cream);overflow-y:auto;';}
  var s1b=document.getElementById('ntS1Body');if(s1b){s1b.style.display='none';s1b.style.flex='';s1b.style.minHeight='';}
  var cb=document.getElementById('ntCompactBar');if(cb)cb.style.display='none';
  var ga=document.getElementById('ntSlGalleryArea');if(ga)ga.style.cssText='padding:20px 18px;flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;';
  if(typeof goToSearchScreen==='function')goToSearchScreen();
}

// ── SLIDER SCREEN CONTROL ──────────────────────────────
function goToEditorScreen(){var eb=document.getElementById('ntEditorBody');if(eb)eb.scrollTop=0;}
function goToSearchScreen(){ntShowInputForm();}

// ── DESIGN IT ──────────────────────────────────────────
function ntDesignIt(){
  // Remove welcome screen if still present
  var _wb=document.getElementById('ntWelcomeBack');if(_wb)_wb.remove();
  var raw=(document.getElementById('ntSlInp')||{}).value||'';
  // Convert literal \n text to real newlines (some users type \n)
  raw=raw.replace(/\\n/g,'\n');
  // Don't stripEmoji on full input — it collapses newlines. Do it per-line below.
  var q=raw;
  var inp=document.getElementById('ntSlInp');
  if(!q.trim()){
    if(inp)inp.focus();
    return;
  }
  // Log search query — detect if routed from Ask Gul
  var _fromGul=sessionStorage.getItem('nt_from_ask_gul')||'';
  if(_fromGul)sessionStorage.removeItem('nt_from_ask_gul');
  try{fetch('https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-log-search',{
    method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({query:q.trim(),session_id:NT_SESSION_ID,source:_fromGul?'ask_gul':'slider'})
  }).catch(function(){});}catch(_e){}
  var sl=document.getElementById('ntSl');if(sl)sl.classList.remove('compact');
  var cb=document.getElementById('ntCompactBar');var ct=document.getElementById('ntCompactText');
  if(ct)ct.textContent=q.trim();if(cb)cb.style.display='flex';
  var fb=document.getElementById('ntFormBar');
  if(fb){fb.classList.add('nt-hidden');fb.style.setProperty('display','none','important');}
  var s1b=document.getElementById('ntS1Body');
  if(s1b){s1b.style.display='flex';s1b.style.flex='1';s1b.style.minHeight='0';s1b.offsetHeight;}
  if(typeof ntTutShowBubble==='function')setTimeout(ntTutShowBubble,800);
  var ga=document.getElementById('ntSlGalleryArea');
  if(ga)ga.style.cssText='display:none !important;height:0;overflow:hidden;padding:0;flex:none;';
  // Strip emoji per-line and remove lines that become empty
  var _hadEmoji=false;
  var rawLines=q.trim().split('\n').map(function(l){
    var stripped=typeof stripEmoji==='function'?stripEmoji(l):l;
    if(stripped.trim()!==l.trim())_hadEmoji=true;
    return stripped.trim();
  }).filter(function(l){
    if(!l)return false;
    // Keep line if it has any letter, digit — catches dates like 05.05.2026
    if(/[a-zA-Z0-9ऀ-ॿ؀-ۿ]/.test(l))return true;
    // Filter lines that are purely separators/dots/dashes
    return false;
  });
    if(_hadEmoji){
    var _eToast=document.getElementById('ntEmojiToast')||document.createElement('div');
    _eToast.id='ntEmojiToast';_eToast.style.cssText='position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:rgba(61,43,26,0.9);color:#fdf6f0;font-size:11px;font-weight:600;padding:7px 14px;border-radius:20px;z-index:9999;font-family:DM Sans,sans-serif;white-space:nowrap;';
    _eToast.textContent='Use the icon section to add icons ✦';
    document.body.appendChild(_eToast);
    setTimeout(function(){if(_eToast.parentNode)_eToast.parentNode.removeChild(_eToast);},3000);
  }
  // If single line with spaces, split on spaces ONLY if words are simple (not dates like 05.05.2026)
  var lines=rawLines.length>1?rawLines.slice(0,4):(function(){
    var words=q.trim().split(/\s+/).filter(Boolean);
    // Don't split if any word contains digits and dots (likely a date)
    var hasDate=words.some(function(w){return /\d+\.\d+/.test(w);});
    return (!hasDate&&words.length>=2&&words.length<=4)?words:rawLines;
  })();
  function waitGoRender(lines,price,n){
    if(typeof goRender==='function'){
      try{goRender(lines,price);}
      catch(e){
        console.error('[goRender crash]',e);
        var fb2=document.getElementById('ntFormBar');
        if(fb2){fb2.classList.remove('nt-hidden');fb2.style.cssText='display:flex;flex-direction:column;flex:1;min-height:0;background:var(--cream);overflow:hidden;';}
        var s1b2=document.getElementById('ntS1Body');if(s1b2)s1b2.style.display='none';
      }
    }
    else if(n<30)setTimeout(function(){waitGoRender(lines,price,n+1);},200);
  }
  var _tiAct2=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
  var _maxL2=_tiAct2?3:4;
  if(lines.length>_maxL2){lines=lines.slice(0,_maxL2);if(typeof window.ntShowLineCap==='function')window.ntShowLineCap(_tiAct2?'Max 3 lines with top icon — trimmed':'Max 4 lines — trimmed to fit');}
  waitGoRender(lines,1299,0);
}
function ntExpandEditBar(){
  var col=document.getElementById('ntCompactCollapsed'),exp=document.getElementById('ntCompactExpanded'),ei=document.getElementById('ntEditInp');
  var t=(document.getElementById('ntCompactText')||{}).textContent||'';
  if(col)col.style.display='none';if(exp)exp.style.display='block';
  if(ei){
    // Strip middle-dot separators when populating edit bar — show clean text
    ei.value=t.replace(/\s*·\s*/g,'\n');
    setTimeout(function(){ei.focus();},50);
  }
}
function ntCollapseEditBar(){
  var col=document.getElementById('ntCompactCollapsed'),exp=document.getElementById('ntCompactExpanded');
  if(col)col.style.display='flex';if(exp)exp.style.display='none';
}
function ntUpdateDesign(){
  var q=(document.getElementById('ntEditInp')||{}).value||'';
  q=q.replace(/\\n/g,'\n');
  // Don't stripEmoji on full input — collapses newlines. Do per-line below.
  if(!q.trim())return;
  // Strip emoji per-line
  var _hadEmoji=false;
  var lines=q.trim().split('\n').map(function(l){
    var s=typeof stripEmoji==='function'?stripEmoji(l):l;
    if(s.trim()!==l.trim())_hadEmoji=true;
    return s.trim();
  }).filter(function(l){
    if(!l)return false;
    if(/[a-zA-Z0-9ऀ-ॿ؀-ۿ]/.test(l))return true;
    return false;
  });
  if(_hadEmoji){
    var _t=document.getElementById('ntEmojiToast2')||document.createElement('div');
    _t.id='ntEmojiToast2';_t.style.cssText='position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:rgba(61,43,26,0.9);color:#fdf6f0;font-size:11px;font-weight:600;padding:7px 14px;border-radius:20px;z-index:9999;font-family:DM Sans,sans-serif;';
    _t.textContent='Use the icon section to add icons ✦';
    document.body.appendChild(_t);setTimeout(function(){if(_t.parentNode)_t.parentNode.removeChild(_t);},3000);
  }
  var ct=document.getElementById('ntCompactText');if(ct)ct.textContent=q.split('\n').filter(Boolean).join(' · ');
  ntCollapseEditBar();
  if(lines.length===1){
    var words=q.split(/\s+/).filter(function(w){return w&&!/^[·\-–—|/\\]+$/.test(w);});
    if(words.length>=2&&words.length<=4)lines=words;
  }

  var _tiAct=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
  var _maxL=_tiAct?3:4;
  if(lines.length>_maxL){lines=lines.slice(0,_maxL);if(typeof window.ntShowLineCap==='function')window.ntShowLineCap(_tiAct?'Max 3 lines with top icon — trimmed':'Max 4 lines — trimmed to fit');}
  var _tiAct=!!(window.s4TopIcon&&window.s4TopIcon.iconKey);
  var _maxL=_tiAct?3:4;
  if(lines.length>_maxL){lines=lines.slice(0,_maxL);if(typeof window.ntShowLineCap==='function')window.ntShowLineCap(_tiAct?'Max 3 lines with top icon — trimmed':'Max 4 lines — trimmed to fit');}
  if(typeof goRender==='function')goRender(lines,1299);
}
function ntShowInputForm(){
  if(typeof ntTutHideBubble==='function')ntTutHideBubble();
  var fb=document.getElementById('ntFormBar'),s1b=document.getElementById('ntS1Body'),cb=document.getElementById('ntCompactBar');
  if(fb){fb.classList.remove('nt-hidden');fb.style.cssText='display:flex;flex-direction:column;flex:1;min-height:0;background:var(--cream);overflow-y:auto;';}
  if(s1b)s1b.style.display='none';if(cb)cb.style.display='none';
}
function ntInitCarousel(){}
function ntFillAndDesign(query){
  var inp=document.getElementById('ntSlInp');if(inp)inp.value=query;ntDesignIt();
}

// ── CART ───────────────────────────────────────────────
// Load Supabase config from Netlify function for design analytics
(function(){fetch('https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/config').then(function(r){return r.json();}).then(function(cfg){window.NT_SB_URL=cfg.supabaseUrl||'';window.NT_SB_KEY=cfg.supabaseKey||'';}).catch(function(){});})();
// ── Sample Pieces Strip ──────────────────────────────────
(function(){
  // pieces read fresh on each call so applyConfig can set them first

  function safeCap(html){
    // Allow only <b> and </b>
    return (html||'').replace(/<(?!\/?b\s*>)[^>]*>/gi,'');
  }

  function buildStrip(scrollId, captionId, stripId){
    var pieces=window.NT_SAMPLE_PIECES||[];
    var caption=window.NT_SAMPLE_CAPTION||"A few samples — cut from a single piece, then hand-carved. <b>We can't show an exact preview, but your text will come out just like these.</b>";
    if(!pieces.length) return;
    var strip = document.getElementById(stripId);
    var scroll = document.getElementById(scrollId);
    var cap = document.getElementById(captionId);
    if(!strip||!scroll||!cap) return;
    cap.innerHTML = safeCap(caption);
    scroll.innerHTML = pieces.map(function(p,i){
      return '<div class="nt-sample-chip" data-i="'+i+'" onclick="ntSampleOpen('+i+')">'
        +'<img src="'+p.src+'" alt="'+(p.alt||'Sample')+'" loading="lazy"></div>';
    }).join('');
    strip.style.display = '';
  }

  window.ntInitSampleStrip = function(){
    buildStrip('ntSampleScroll','ntSampleCaption','ntSampleStrip');
    buildStrip('ntSampleScrollQ','ntSampleCaptionQ','ntSampleStripQ');
  };

  // Overlay
  var ovCur = 0;
  var ovEl = null;

  function getOrCreateOverlay(){
    if(ovEl) return ovEl;
    ovEl = document.createElement('div');
    ovEl.className = 'nt-sample-overlay';
    ovEl.innerHTML = '<div class="nt-sample-ov-inner" onclick="event.stopPropagation()">'
      +'<div class="nt-sample-ov-top">'
      +'<div class="nt-sample-ov-caption" id="ntOvCaption"></div>'
      +'<button class="nt-sample-ov-close" onclick="ntSampleClose()">✕</button>'
      +'</div>'
      +'<div class="nt-sample-ov-img"><img id="ntOvImg" src="" alt="Sample"></div>'
      +'<div class="nt-sample-ov-nav">'
      +'<button class="nt-sample-ov-btn" onclick="ntSampleNav(-1)">‹</button>'
      +'<div class="nt-sample-dots" id="ntOvDots"></div>'
      +'<button class="nt-sample-ov-btn" onclick="ntSampleNav(1)">›</button>'
      +'</div>'
      +'</div>';
    ovEl.addEventListener('click', function(e){ if(e.target===ovEl) ntSampleClose(); });
    document.body.appendChild(ovEl);
    return ovEl;
  }

  function renderOverlay(){
    var pieces=window.NT_SAMPLE_PIECES||[];
    var caption=window.NT_SAMPLE_CAPTION||'';
    var ov = getOrCreateOverlay();
    var p = pieces[ovCur];
    if(!p)return;
    document.getElementById('ntOvImg').src = p.srcZoom || p.src;
    document.getElementById('ntOvCaption').innerHTML = safeCap(caption);
    var dots = document.getElementById('ntOvDots');
    dots.innerHTML = pieces.map(function(_,i){
      return '<div class="nt-sample-dot" style="width:'+(i===ovCur?18:6)+'px;background:'+(i===ovCur?'#fff':'rgba(255,255,255,0.3)')+';"></div>';
    }).join('');
  }

  window.ntSampleOpen = function(i){
    ovCur = i;
    getOrCreateOverlay().classList.add('open');
    renderOverlay();
  };
  window.ntSampleClose = function(){
    if(ovEl) ovEl.classList.remove('open');
  };
  window.ntSampleNav = function(d){
    var pieces=window.NT_SAMPLE_PIECES||[];
    ovCur = (ovCur + d + pieces.length) % pieces.length;
    renderOverlay();
  };

// expose to window
window._ntTutInit=_ntTutInit;
window._ntTutToEmbed=_ntTutToEmbed;
window.goToEditorScreen=goToEditorScreen;
window.goToSearchScreen=goToSearchScreen;
window.ntAddToCart=ntAddToCart;
window.ntApplyBottomSection=ntApplyBottomSection;
window.ntApplyConfigTexts=ntApplyConfigTexts;
window.ntAutoSave=ntAutoSave;
window.ntBuildReviewsCarousel=ntBuildReviewsCarousel;
window.ntClearAllDesigns=ntClearAllDesigns;
window.ntCloseIconLetter=ntCloseIconLetter;
window.ntClosePolicy=ntClosePolicy;
window.ntCloseSizeGuideModal=ntCloseSizeGuideModal;
window.ntCloseSlider=ntCloseSlider;
window.ntCollapseEditBar=ntCollapseEditBar;
window.ntCommissionMantra=ntCommissionMantra;
window.ntCommissionPersonal=ntCommissionPersonal;
window.ntCommissionQuote=ntCommissionQuote;
window.ntDeleteDesign=ntDeleteDesign;
window.ntDesignIt=ntDesignIt;
window.ntDismissNavHelper=ntDismissNavHelper;
window.ntEditSaved=ntEditSaved;
window.ntExpandEditBar=ntExpandEditBar;
window.ntFillAndDesign=ntFillAndDesign;
window.ntGetPrice=ntGetPrice;
window.ntGetVariantId=ntGetVariantId;
window.ntILShowFloat=ntILShowFloat;
window.ntInitArtisan=ntInitArtisan;
window.ntInitCarousel=ntInitCarousel;
window.ntInitReviewScroll=ntInitReviewScroll;
window.ntInitVideoReviews=ntInitVideoReviews;
window.ntInjectCartProps=ntInjectCartProps;
window.ntLoadDesigns=ntLoadDesigns;
window.ntLoadReviews=ntLoadReviews;
window.ntOpenBrandLogo=ntOpenBrandLogo;
window.ntOpenCartFromBar=ntOpenCartFromBar;
window.ntOpenIconLetter=ntOpenIconLetter;
window.ntOpenPolicy=ntOpenPolicy;
window.ntOpenSizeGuide=ntOpenSizeGuide;
window.ntOpenSizeGuideModal=ntOpenSizeGuideModal;
window.ntOpenSlider=ntOpenSlider;
window.ntPlayVideoS4=ntPlayVideoS4;
window.ntPlayVideoV=ntPlayVideoV;
window.ntRefreshIconLetterRow=ntRefreshIconLetterRow;
window.ntRefreshSavedDesigns=ntRefreshSavedDesigns;
window.ntRemoveLetterIcon=ntRemoveLetterIcon;
window.ntSGOpenLightbox=ntSGOpenLightbox;
window.ntSaveDesign=ntSaveDesign;
window.ntScalePiece=ntScalePiece;
window.ntScrollToFind=ntScrollToFind;
window.ntShowInputForm=ntShowInputForm;
window.ntShowWelcomeBack=ntShowWelcomeBack;
window.ntToggleFaq=ntToggleFaq;
window.ntTutClose=ntTutClose;
window.ntTutDismiss=ntTutDismiss;
window.ntTutHideBubble=ntTutHideBubble;
window.ntTutMinimise=ntTutMinimise;
window.ntTutOpen=ntTutOpen;
window.ntTutShowBubble=ntTutShowBubble;
window.ntUpdateCartBtn=ntUpdateCartBtn;
window.ntUpdateDesign=ntUpdateDesign;
window.ntUpdatePersonalBtn=ntUpdatePersonalBtn;
window.ntWelcomeEdit=ntWelcomeEdit;
window.ntWelcomeStartFresh=ntWelcomeStartFresh;

})();

const NT_SESSION_ID='nt_'+Date.now()+'_'+Math.random().toString(36).slice(2,7);
async function ntAddToCart(lines,inch,intent,qty){
  qty=qty||1;
  var lc=Math.min((lines||[]).length,4),ai=Math.min(Math.max(inch,8),24);
  var variantId=ntGetVariantId(ai,lc),price=ntGetPrice(ai,lc);
  // Add icon colour extra (₹500 per custom colour, max ₹2000)
  var _textCol=(ntGetColors()[window.selC4||0]||{}).fc||'';
  var _icColCount=0;
  (window.s4LineOpts||[]).concat(window.s4NameLineOpts||[]).forEach(function(o){
    if(o&&o.iconKey&&o.iconColour&&o.iconColour!==_textCol)_icColCount++;
  });
  // Top icon custom colour
  var _ti=window.s4TopIcon||{};
  if(_ti.iconKey&&_ti.iconColour&&_ti.iconColour!==_textCol)_icColCount++;
  var _icColExtra=Math.min(_icColCount,4)*500;
  price+=_icColExtra;
  var designerOn=window.designerState&&Object.values(window.designerState).some(function(v){return v;});
  var btn=document.getElementById(intent==='personal'?'s4Btn':'commBtn');
  var origTxt=btn?btn.textContent:'';
  if(btn){btn.textContent='Adding…';btn.disabled=true;}
  if(!variantId){if(btn){btn.textContent='Error';btn.disabled=false;}return;}
  // Log design to Supabase for analytics
  try{
    var _sbUrl=(window.NT_SB_URL||'');var _sbKey=(window.NT_SB_KEY||'');
    if(_sbUrl&&_sbKey){
      var _logData={
        session_id:NT_SESSION_ID,
        lines:lines.join(' · '),
        line_count:lc,
        inch:ai,
        price:price,
        intent:intent,
        commissioned:intent==='personal'||intent==='mantra',
        device:window.innerWidth<768?'mobile':'desktop',
        page:window.location.pathname,
        created_at:new Date().toISOString()
      };
      fetch(_sbUrl+'/rest/v1/nt_custom_designs',{
        method:'POST',
        headers:{'Content-Type':'application/json','apikey':_sbKey,'Authorization':'Bearer '+_sbKey,'Prefer':'return=minimal'},
        body:JSON.stringify(_logData)
      }).catch(function(){});
    }
  }catch(_e){}
  var props={};
  props['Size']=ai+'"';
  props['_session']=NT_SESSION_ID;
  // Build per-line properties
  lines.forEach(function(l,i){
    var _lineStr=l;
    var _opt=window.s4LineOpts&&window.s4LineOpts[i];
    if(_opt&&_opt.iconKey){
      var _label=_opt.iconLabel||(_opt.iconKey.split('/').pop().split('?')[0].replace(/[-_]?[a-f0-9]{8,}[-_]?[a-f0-9]*/gi,'').replace(/\.[^.]+$/,'').replace(/[-_]+/g,' ').trim())||'icon';
      var _iconDetail=_label+' · '+(_opt.iconSide||'left');
      if(_opt.iconRotation)_iconDetail+=' · '+_opt.iconRotation+'°';
      if(_opt.iconFlip)_iconDetail+=' · flipped';
      if(_opt.iconColour&&_opt.iconColour!==_textCol)_iconDetail+=' · '+(_opt.iconColourName||ntHexToName(_opt.iconColour)||_opt.iconColour)+' colour';
      _lineStr+=' + '+_iconDetail;
    }
    props['Line '+(i+1)]=_lineStr;
  });
  // For personal, nameLines already merged into lines arg — skip to avoid duplication
  var _nameLinesToLog=intent==='personal'?[]:(window.s4NameLines||[]).filter(Boolean);
  _nameLinesToLog.forEach(function(l,ni){
    var _lineStr=l;
    var _nopt=window.s4NameLineOpts&&window.s4NameLineOpts[ni];
    if(_nopt&&_nopt.iconKey){
      var _label=_nopt.iconLabel||(_nopt.iconKey.split('/').pop().split('?')[0].replace(/[-_]?[a-f0-9]{8,}[-_]?[a-f0-9]*/gi,'').replace(/\.[^.]+$/,'').replace(/[-_]+/g,' ').trim())||'icon';
      _lineStr+=' + '+_label+' ('+(_nopt.iconSide||'left')+')';
    }
    props['Line '+(lines.length+ni+1)]=_lineStr;
  }); // end nameLines
  // Font
  var _f4=window.selFont4||'sans';
  var _f3=window.selFont||'sans';
  var _fRaw=intent==='personal'?_f4:_f3;
  var _fontNames={'serif':'Classic (Playfair)','pacifico':'Flowing (Pacifico)','lobster':'Casual (Lobster)','amaranth':'Rounded (Amaranth)','montserrat':'Bold (Montserrat)','teko':'Impact (Teko)','comic':'Quirky (Comic Neue)','andalusia':'Script (Andalusia)','recoleta':'Recoleta','hindi':'Hindi','script':'Script (Pacifico)','sans':'Default (Poppins)'};
  var _fontName=_fontNames[_fRaw]||_fRaw||'Bold';
  props['Font']=_fontName;
  // Color
  var _cols=ntGetColors();var _col=_cols[intent==='personal'?(window.selC4||0):(window.selC3||0)];
  if(_col)props['Colour']=_col.n;
  // Note
  var _note=(document.getElementById('ntNoteText')||{}).value||'';
  if(_note.trim())props['Designer note']=_note.trim();


  if(_icColExtra>0)props['_iconColourExtra']='₹'+_icColExtra;
  // Wide lines
  if(typeof ntWideExtra==='function'&&typeof ntWideEligible==='function'){
    var _wideLines=(window.lineOpts||[]).map(function(o,i){return o&&o.wide&&ntWideEligible(i,lines)?lines[i]:null;}).filter(Boolean);
    if(_wideLines.length) props['_WideLines']=_wideLines.join(', ');
    var _wideAmt=ntWideExtra(lines,window.lineOpts||[]);
    if(_wideAmt) props['_WideExtra']='₹'+_wideAmt;
  }
  // Icon on letter
  if(window.ntLetterIcon&&window.ntLetterIcon.active){
    var _ilLabel=window.ntLetterIcon.iconLabel||(window.ntLetterIcon.iconSrc.split('/').pop().split('?')[0].replace(/[-_]?[a-f0-9]{8,}[-_]?[a-f0-9]*/gi,'').replace(/\.[^.]+$/,'').replace(/[-_]+/g,' ').trim())||'crown';
    props['Crown icon']=_ilLabel+' (on line '+(window.ntLetterIcon.line+1)+')';
  }
  // Top icon
  var _ti=window.s4TopIcon||{};
  if(_ti&&_ti.iconKey){
    var _tiLabel=_ti.iconLabel||(_ti.iconKey.split('/').pop().split('?')[0].replace(/[-_]?[a-f0-9]{8,}[-_]?[a-f0-9]*/gi,'').replace(/\.[^.]+$/,'').replace(/[-_]+/g,' ').trim())||'icon';
    var _tiStr=_tiLabel;
    if(_ti.iconRotation)_tiStr+=' · rotated '+_ti.iconRotation+'°';
    if(_ti.iconFlip)_tiStr+=' · mirrored';
    if(_ti.iconColour&&_ti.iconColour!==_textCol){
      var _tiColName=_ti.iconColourName||ntHexToName(_ti.iconColour)||_ti.iconColour;
      _tiStr+=' · '+_tiColName+' colour (+₹500)';
      _icColExtra+=500;
    }
    props['Top icon']=_tiStr;
  }
  // ── Canvas snapshot — native canvas, wait for fonts ──
  (function(){
    try{
      var _sbUrl=window.NT_SB_URL||'';
      var _sbKey=window.NT_SB_KEY||'';
      if(!_sbUrl||!_sbKey)return;
      var _bgEl=document.getElementById('s4Bg')||document.getElementById('pieceBg');
      if(!_bgEl)return;

      // Capture design data now for logging after upload
      var _logData={session_id:NT_SESSION_ID,lines:lines,inch:ai,price:price,
        font:props['Font']||'',colour:props['Colour']||'',
        icons:props['Icons']||'',crown_icon:props['Crown icon']||'',commissioned:true};
      window._ntPendingLog=_logData;

      function doCapture(){
        var _allLines=(window.curLines||[]).concat((window.s4NameLines||[]).filter(Boolean));
        if(!_allLines.length)return;
        var _cols=typeof ntGetColors==='function'?ntGetColors():[];
        var _ci=window.selC4||0;
        var _color=(_cols[_ci]&&_cols[_ci].fc)||'#3d2b1a';
        var _pad=28,_lineH=60,_w=320;
        var _h=_pad*2+_allLines.length*_lineH;
        var _scale=2;
        var _cv=document.createElement('canvas');
        _cv.width=_w*_scale;_cv.height=_h*_scale;
        var _ctx=_cv.getContext('2d');
        _ctx.scale(_scale,_scale);
        var _bgColor=(_cols[_ci]&&_cols[_ci].lt)?'#f0f0f0':'#ffffff';
        _ctx.fillStyle=_bgColor;_ctx.fillRect(0,0,_w,_h);
        _ctx.fillStyle=_color;
        _ctx.textAlign='center';_ctx.textBaseline='middle';
        _allLines.forEach(function(line,idx){
          var _text=(line||'').trim();if(!_text)return;
          _ctx.font='900 48px Poppins,sans-serif';
          var _mw=_w-_pad*2;
          var _m=_ctx.measureText(_text);
          if(_m.width>_mw){var _ratio=_mw/_m.width;_ctx.font='900 '+Math.floor(48*_ratio)+'px Poppins,sans-serif';}
          _ctx.fillText(_text,_w/2,_pad+idx*_lineH+_lineH/2);
        });
        _cv.toBlob(function(blob){
          if(!blob)return;
          var _fname='designs/'+NT_SESSION_ID+'_'+Date.now()+'.jpg';
          fetch(_sbUrl+'/storage/v1/object/nt-designs/'+_fname,{
            method:'POST',
            headers:{'Authorization':'Bearer '+_sbKey,'apikey':_sbKey,'Content-Type':'image/jpeg','x-upsert':'true'},
            body:blob
          }).then(function(r){
            if(!r.ok)return;
            var _url=_sbUrl+'/storage/v1/object/public/nt-designs/'+_fname;
            window._ntLastPreviewUrl=_url;
            // Log design NOW — after upload, so preview_url is ready
            var _ld=window._ntPendingLog||{};
            _ld.preview_url=_url;
            fetch('https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-log-design',{
              method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(_ld)
            }).catch(function(){});
          }).catch(function(){
            // Upload failed — log without preview
            var _ld=window._ntPendingLog||{};
            _ld.preview_url=null;
            fetch('https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-log-design',{
              method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(_ld)
            }).catch(function(){});
          });
        },'image/jpeg',0.85);
      }

      if(document.fonts&&document.fonts.ready){document.fonts.ready.then(doCapture);}
      else{setTimeout(doCapture,600);}
    }catch(e){}
  })();

  var items=[{id:variantId,quantity:qty,properties:props}];
  console.log('[NukkadTales] Cart properties:', JSON.stringify(props));
  if(designerOn&&window.NT_DESIGNER_VARIANT_ID)items.push({id:window.NT_DESIGNER_VARIANT_ID,quantity:1});
  // Add icon colour variant if any custom icon colours selected
  if(_icColCount>0&&window.NT_ICON_COLOUR_VARIANTS&&window.NT_ICON_COLOUR_VARIANTS[_icColCount]){
    items.push({id:window.NT_ICON_COLOUR_VARIANTS[_icColCount],quantity:1});
  }
  try{
    var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})});
    if(!r.ok)throw new Error(r.status);
    ntSaveDesign({lines:lines,inch:ai,intent:intent,session:NT_SESSION_ID,date:new Date().toLocaleDateString('en-IN',{day:'numeric',month:'short'}),commissioned:true});
    if(btn){btn.textContent='✓ Added!';btn.style.background='#2d7d46';setTimeout(function(){btn.textContent=origTxt;btn.style.background='';btn.disabled=false;},2500);}
    // Open Sense theme cart drawer
    ntUpdateCartBtn();
    setTimeout(function(){
      ntCloseSlider();
      var drawer=document.querySelector('cart-drawer');
      if(drawer){
        // Fetch updated cart sections then open drawer
        fetch(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root+'?sections=cart-drawer,cart-icon-bubble':'/?sections=cart-drawer,cart-icon-bubble')
          .then(function(r){return r.json();})
          .then(function(sections){
            if(sections['cart-drawer']){
              var cartEl=document.getElementById('CartDrawer');
              if(cartEl){
                var html=new DOMParser().parseFromString(sections['cart-drawer'],'text/html');
                var inner=html.querySelector('#CartDrawer');
                if(inner)cartEl.innerHTML=inner.innerHTML;
              }
            }
            if(sections['cart-icon-bubble']){
              var bubble=document.getElementById('cart-icon-bubble');
              if(bubble){
                var html2=new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
                var inner2=html2.querySelector('#cart-icon-bubble');
                if(inner2)bubble.innerHTML=inner2.innerHTML;
              }
            }
            // Inject design properties into cart drawer items
            // ntInjectCartProps disabled temporarily
          })
          .catch(function(){})
          .finally(function(){
            drawer.classList.remove('is-empty');
            drawer.open();
          });
      } else {
        // Fallback — go to cart page
        window.location.href='/cart';
      }
    },500);
  }catch(e){if(btn){btn.textContent='Try again';btn.style.background='#c0392b';setTimeout(function(){btn.textContent=origTxt;btn.style.background='';btn.disabled=false;},2500);}}
}
function ntCommissionQuote(){
  var ai=Math.min(Math.max(window.customSizeOverride||calcSizePrice(window.curLines,false,window.lineOpts||[]).inch,8),24);
  ntAddToCart(window.curLines,ai,'quote',parseInt(document.getElementById('qtyCurrent')?.textContent||'1'));
}
function ntCommissionPersonal(){
  var nl=(window.s4NameLines||[]).filter(Boolean);
  var al=nl.length?[...curLines,...nl]:[...curLines];
  // Use s4LineOpts (not lineOpts) — s4 stage icons and overrides live here
  var adjOpts=[...(window.s4LineOpts||[]),...(window.s4NameLineOpts||[]).slice(0,nl.length)];
  var ai=Math.min(Math.max(window.customSizeOverride||calcSizePrice(al,true,adjOpts).inch,8),24);
  ntAddToCart(al,ai,'personal',parseInt(document.getElementById('qtyCurrentS4')?.textContent||'1'));
}
function ntCommissionMantra(){
  ntAddToCart(window.mantraLines,window.mantraCurInch,'mantra',window.mantraQtyVal||1);
}
function ntUpdatePersonalBtn(){
  var nl=(window.s4NameLines||[]).filter(Boolean),al=[...curLines,...nl];
  if(!al.length)return;
  var adjOpts=[...(window.s4LineOpts||[]),...(window.s4NameLineOpts||[]).slice(0,nl.length)];
  var ai=Math.min(Math.max(window.customSizeOverride||calcSizePrice(al,true,adjOpts).inch,8),24);
  var p=ntGetPrice(ai,Math.min(al.length,4));
  var d=window.designerState&&Object.values(window.designerState).some(function(v){return v;});
  var btn=document.getElementById('s4Btn');
  if(btn)btn.textContent='Add to Cart · ₹'+(p+(d?500:0)).toLocaleString('en-IN');
}

function ntInjectCartProps(){
  // Fetch current cart and inject properties under each NT custom item in drawer
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    cart.items.forEach(function(item){
      if(!item.properties||!Object.keys(item.properties).length)return;
      // Find the cart item element by variant id or key
      var selectors=[
        '[data-variant-id="'+item.variant_id+'"]',
        '[data-line-item-key="'+item.key+'"]',
        '[href*="'+item.variant_id+'"]'
      ];
      var el=null;
      selectors.forEach(function(s){if(!el)el=document.querySelector(s);});
      if(!el){
        // fallback: find by product title text
        document.querySelectorAll('.cart-item__name, .cart-item__title, h3').forEach(function(h){
          if(!el&&h.textContent.includes('NukkadTales'))el=h.closest('li, .cart-item, tr');
        });
      }
      if(!el)return;
      if(el.querySelector('.nt-cart-props'))return; // already injected
      var div=document.createElement('div');
      div.className='nt-cart-props';
      div.style.cssText='font-size:11px;color:#555;margin-top:4px;line-height:1.6;';
      var lines=[];
      Object.entries(item.properties).forEach(function(kv){
        var k=kv[0],v=kv[1];
        if(!v||k.startsWith('_'))return; // skip blank and internal
        lines.push('<span style="font-weight:600;color:#3d2b1a;">'+k+':</span> '+v);
      });
      div.innerHTML=lines.join('<br>');
      el.appendChild(div);
    });
  }).catch(function(){});
}
window.ntInjectCartProps=ntInjectCartProps;
// Also run on page load for cart page
// ntInjectCartProps auto-run disabled temporarily
function ntOpenPolicy(){var ov=document.getElementById('ntPolicyOverlay'),m=document.getElementById('ntPolicyModal');if(ov)ov.style.display='block';if(m){m.style.display='flex';setTimeout(function(){m.style.transform='translateY(0)';},10);}}
function ntClosePolicy(){var m=document.getElementById('ntPolicyModal'),ov=document.getElementById('ntPolicyOverlay');if(m){m.style.transform='translateY(100%)';setTimeout(function(){m.style.display='none';},300);}if(ov)ov.style.display='none';}
function ntScalePiece(){var bg=document.getElementById('pieceBg')||document.getElementById('s4Bg');if(!bg)return;var p=bg.querySelector('.nt-piece');if(!p)return;p.style.transform='scale(1)';var s=Math.min(1,(bg.clientWidth-40)/p.scrollWidth,(bg.clientHeight-40)/p.scrollHeight);p.style.transform='scale('+s+')';}
// Init sample strip when slider DOM ready
try{if(typeof ntInitSampleStrip==='function')ntInitSampleStrip();}catch(e){}

function ntSaveDesign(design){
  try{
    var saved=JSON.parse(localStorage.getItem('nt_designs')||'[]');
    saved=saved.filter(function(d){return d.session!==design.session;});
    saved.unshift(design);
    if(saved.length>20)saved=saved.slice(0,20); // keep last 20
    localStorage.setItem('nt_designs',JSON.stringify(saved));
    ntRefreshSavedDesigns();
  }catch(e){}
}

// Auto-save current design while editing (debounced)
var _ntSaveTimer=null;
function ntAutoSave(){
  clearTimeout(_ntSaveTimer);
  _ntSaveTimer=setTimeout(function(){
    if(typeof window.curLines==='undefined'||!window.curLines||!window.curLines.length)return;
    // Stable key based on content — prevents duplicate on every render
    var _stableKey='draft_'+window.curLines.filter(Boolean).join('|').toLowerCase().replace(/\s+/g,'_').slice(0,50);
    // Don't re-save if this exact content was deleted
    var _deleted=[];
    try{_deleted=JSON.parse(localStorage.getItem('nt_deleted')||'[]');}catch(e){}
    if(_deleted.indexOf(_stableKey)>=0)return;
    ntSaveDesign({
      lines:window.curLines.slice(),
      inch:window.customSizeOverride||8,
      intent:window.isNamed?'personal':'quote',
      session:_stableKey,
      date:new Date().toLocaleDateString('en-IN',{day:'numeric',month:'short'}),
      draft:true,
      font:window.selFont4||window.selFont||'sans',
      colour:window.selC4!=null?window.selC4:window.selC3,
      lineOpts:(window.s4LineOpts||[]).map(function(o){
        if(!o)return null;
        return {iconKey:o.iconKey||null,iconLabel:o.iconLabel||null,iconSide:o.iconSide||'left',iconRotation:o.iconRotation||0,iconColour:o.iconColour||null,iconColourName:o.iconColourName||null,wide:!!o.wide,align:o.align||null,fontOverride:o.fontOverride||null};
      }),
      nameLineOpts:(window.s4NameLineOpts||[]).map(function(o){
        if(!o)return null;
        return {iconKey:o.iconKey||null,iconLabel:o.iconLabel||null,iconSide:o.iconSide||'left',iconColour:o.iconColour||null,iconColourName:o.iconColourName||null};
      }),
      nameLines:(window.s4NameLines||[]).slice(),
      topIcon:window.s4TopIcon?{iconKey:window.s4TopIcon.iconKey||null,iconLabel:window.s4TopIcon.iconLabel||null,iconColour:window.s4TopIcon.iconColour||null,iconRotation:window.s4TopIcon.iconRotation||0,iconFlip:!!window.s4TopIcon.iconFlip}:null,
      letterIcon:(window.ntLetterIcon&&window.ntLetterIcon.active)?Object.assign({},window.ntLetterIcon):null
    });
  },2000);
}

function ntClearAllDesigns(){
  if(!window.confirm('Remove all saved designs?'))return;
  localStorage.removeItem('nt_designs');
  localStorage.removeItem('nt_deleted');
  ntRefreshSavedDesigns();
}

function ntLoadDesigns(){
  try{return JSON.parse(localStorage.getItem('nt_designs')||'[]');}catch(e){return[];}
}

function ntDeleteDesign(session,confirmed){
  try{
    var designs=ntLoadDesigns();
    var d=designs.find(function(x){return x.session===session;});
    // If commissioned, confirm before deleting
    if(d&&d.commissioned&&!confirmed){
      if(!window.confirm('This design was added to cart. Still remove from saved designs?'))return;
    }
    var saved=designs.filter(function(x){return x.session!==session;});
    localStorage.setItem('nt_designs',JSON.stringify(saved));
    // Add to deleted blocklist so autoSave won't re-add it
    var _deleted=[];
    try{_deleted=JSON.parse(localStorage.getItem('nt_deleted')||'[]');}catch(e){}
    if(_deleted.indexOf(session)<0){_deleted.push(session);localStorage.setItem('nt_deleted',JSON.stringify(_deleted.slice(-50)));}
    ntRefreshSavedDesigns();
  }catch(e){}
}

function ntRefreshSavedDesigns(){
  var wrap=document.getElementById('ntSavedDesigns');
  var designs=ntLoadDesigns();
  if(!wrap)return;
  if(!designs.length){wrap.style.display='none';return;}
  wrap.style.display='block';
  var html='<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">'
    +'<div style="font-size:10px;font-weight:700;color:var(--muted);letter-spacing:.08em;text-transform:uppercase;">Your saved designs</div>'
    +'<button onclick="ntClearAllDesigns()" style="font-size:10px;font-weight:600;color:var(--muted);background:none;border:none;cursor:pointer;text-decoration:underline;font-family:\'DM Sans\',sans-serif;">Clear all</button>'
    +'</div>';
  designs.forEach(function(d,idx){
    var label=d.lines.join(' · ').slice(0,30)+(d.lines.join(' · ').length>30?'…':'');
    var price=d.intent==='personal'?'₹1,299':'₹999';
    var commBadge=d.commissioned?'<span style="font-size:9px;font-weight:700;color:#2d7d46;background:#e8f5ec;border-radius:20px;padding:2px 7px;margin-left:4px;">Ordered ✓</span>':'';
    html+='<div style="background:#fff;border:1px solid var(--border);border-radius:10px;padding:10px 12px;margin-bottom:8px;display:flex;align-items:center;gap:10px;">'
      +'<div style="flex:1;min-width:0;">'
      +'<div style="font-size:12px;font-weight:700;color:var(--brown);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+label+commBadge+'</div>'
      +'<div style="font-size:10px;color:var(--muted);margin-top:2px;">'+d.date+' · '+d.inch+'" · '+price+'</div>'
      +'</div>'
      +'<button onclick="ntEditSaved(\''+idx+'\')" style="background:var(--orange);color:#fff;border:none;border-radius:20px;padding:6px 12px;font-size:11px;font-weight:700;cursor:pointer;font-family:\'DM Sans\',sans-serif;white-space:nowrap;flex-shrink:0;">Edit →</button>'
      +'<button onclick="ntDeleteDesign(\''+d.session+'\')" style="background:none;border:none;font-size:16px;color:var(--light);cursor:pointer;flex-shrink:0;padding:0 2px;">✕</button>'
      +'</div>';
  });
  wrap.innerHTML=html;
}

function ntEditSaved(idx){
  var designs=ntLoadDesigns();
  var d=designs[parseInt(idx)];
  if(!d||!d.lines||!d.lines.length)return;
  var sl=document.getElementById('ntSl');
  var alreadyOpen=sl&&sl.classList.contains('open');
  if(!alreadyOpen){
    sessionStorage.setItem('nt_skip_welcome','1');
    ntOpenSlider('customise');
  } else {
    var _wb=document.getElementById('ntWelcomeBack');if(_wb)_wb.remove();
  }
  setTimeout(function(){if(typeof ntTutShowBubble==='function')ntTutShowBubble();},1000);
  var price=d.intent==='personal'?1299:999;
  function tryEdit(n){
    if(typeof goRender==='function'){
      var fb=document.getElementById('ntFormBar');
      var s1b=document.getElementById('ntS1Body');
      var cb=document.getElementById('ntCompactBar');
      var ct=document.getElementById('ntCompactText');
      if(fb){fb.classList.add('nt-hidden');fb.style.setProperty('display','none','important');}
      if(s1b){s1b.style.display='flex';s1b.style.flex='1';s1b.style.minHeight='0';}
      if(cb)cb.style.display='flex';
      if(ct)ct.textContent=d.lines.join(' · ');
      window.customSizeOverride=d.inch||null;
      goRender(d.lines,price);
      // Restore ALL state AFTER goRender/initS4 resets everything
      setTimeout(function(){
        if(d.lineOpts){window.s4LineOpts=d.lineOpts.map(function(o){return o?Object.assign({},o):{};}); }
        if(d.nameLineOpts){window.s4NameLineOpts=d.nameLineOpts.map(function(o){return o?Object.assign({},o):{};}); }
        if(d.nameLines){window.s4NameLines=d.nameLines.slice();}
        if(d.topIcon&&d.topIcon.iconKey){window.s4TopIcon=Object.assign({},d.topIcon);} else {window.s4TopIcon={};}
        if(d.letterIcon&&d.letterIcon.active){window.ntLetterIcon=Object.assign({},d.letterIcon);} else {window.ntLetterIcon={active:false,letter:'',line:0,charIdx:0,iconSrc:'',iconLabel:''};}
        if(d.colour!=null&&typeof pc4==='function'){try{pc4(d.colour);}catch(e){}}
        if(d.font&&typeof setFont4==='function'){try{setFont4(d.font);}catch(e){}}
        if(typeof renderS4==='function')try{renderS4();}catch(e){}
        if(typeof renderC4==='function')try{renderC4();}catch(e){}
        if(typeof renderS4LineChips==='function')try{renderS4LineChips();}catch(e){}
        if(typeof ntRenderIconColourPill==='function')try{ntRenderIconColourPill();}catch(e){}
      },300);
    } else if(n<20){
      setTimeout(function(){tryEdit(n+1);},150);
    }
  }
  // Always wait a tick to ensure goRender is available
  if(alreadyOpen){setTimeout(function(){tryEdit(0);},50);}
  else{setTimeout(function(){tryEdit(0);},400);}
}

function ntOpenSizeGuide(){
  // Build modal if not exists
  var existing=document.getElementById('ntSizeGuideModal');
  if(existing){existing.style.display='flex';return;}

  var modal=document.createElement('div');
  modal.id='ntSizeGuideModal';
  modal.style.cssText='position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.6);display:flex;align-items:flex-end;justify-content:center;';

  var panel=document.createElement('div');
  panel.style.cssText='background:#fdf6f0;border-radius:20px 20px 0 0;width:100%;max-width:480px;max-height:85vh;overflow-y:auto;padding:20px;box-sizing:border-box;';

  // Header
  var header='<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;">'
    +'<div style="font-size:15px;font-weight:700;color:var(--brown);">📐 Size Guide</div>'
    +'<button onclick="document.getElementById(\'ntSizeGuideModal\').style.display=\'none\'" style="background:none;border:none;font-size:20px;color:var(--muted);cursor:pointer;padding:0;line-height:1;">✕</button>'
    +'</div>';

  // Size reference cards
  var sizes=[
    {s:'6"',  icon:'🪔', desc:'Candle / small shelf piece',   who:'Studio apartment, gifting'},
    {s:'8"',  icon:'📱', desc:'Phone size · compact desk decor', who:'Desk, bedside, gifting'},
    {s:'9"',  icon:'📓', desc:'Notebook size · most popular',  who:'Home office, living room'},
    {s:'10"', icon:'📄', desc:'A4 paper · bold shelf statement',who:'Shelf, console table'},
    {s:'12"', icon:'💻', desc:'Laptop width · wall statement', who:'Living room, entryway'},
    {s:'14"', icon:'🖼️', desc:'Art print · bold wall piece',   who:'Feature wall, office'},
  ];

  var cards='<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:16px;">'
    +sizes.map(function(sz){
      return '<div style="background:#fff;border:1px solid var(--border);border-radius:10px;padding:10px;">'
        +'<div style="display:flex;align-items:center;gap:6px;margin-bottom:4px;">'
        +'<span style="font-size:18px;">'+sz.icon+'</span>'
        +'<span style="font-size:14px;font-weight:800;color:var(--brown);font-family:\'Poppins\',sans-serif;">'+sz.s+'</span>'
        +'</div>'
        +'<div style="font-size:10px;color:var(--brown);font-weight:600;line-height:1.4;">'+sz.desc+'</div>'
        +'<div style="font-size:9px;color:var(--muted);margin-top:3px;">'+sz.who+'</div>'
        +'</div>';
    }).join('')
    +'</div>';

  // Video section — populated from NUKKAD_CONFIG if set
  var videoHtml='';
  if(NUKKAD_CONFIG&&NUKKAD_CONFIG.videoUrl){
    videoHtml='<div style="margin-bottom:16px;">'
      +'<div style="font-size:11px;font-weight:700;color:var(--muted);letter-spacing:.06em;text-transform:uppercase;margin-bottom:8px;">Watch: sizes in real homes</div>'
      +'<div style="background:#1e1408;border-radius:10px;overflow:hidden;aspect-ratio:16/9;cursor:pointer;position:relative;" onclick="this.innerHTML=\'<iframe src=\\\''+NUKKAD_CONFIG.videoUrl+'?autoplay=1\\\' width=\\\'100%\\\' height=\\\'100%\\\' frameborder=\\\'0\\\' allowfullscreen style=\\\'display:block;\\\'></iframe>\';this.style.cursor=\'default\';">'
      +'<img src="'+(NUKKAD_CONFIG.videoThumbnail||'')+'" style="width:100%;height:100%;object-fit:cover;opacity:0.7;" loading="lazy">'
      +'<div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;">'
      +'<div style="width:44px;height:44px;background:rgba(255,255,255,0.9);border-radius:50%;display:flex;align-items:center;justify-content:center;">'
      +'<svg width="16" height="16" viewBox="0 0 24 24" fill="#3d2b1a"><path d="M8 5v14l11-7z"/></svg>'
      +'</div></div></div></div>';
  }

  // Size comparison photos placeholder
  var photosHtml='<div style="background:#fff;border:1px dashed var(--border);border-radius:10px;padding:14px;text-align:center;">'
    +'<div style="font-size:11px;color:var(--muted);line-height:1.6;">Size comparison photos coming soon.<br>Call us to see samples: <a href="tel:+91XXXXXXXXXX" style="color:var(--orange);font-weight:700;">+91 XXXX XXX XXX</a></div>'
    +'</div>';

  panel.innerHTML=header+cards+videoHtml+photosHtml;
  modal.appendChild(panel);
  modal.addEventListener('click',function(e){if(e.target===modal)modal.style.display='none';});
  document.body.appendChild(modal);
}

function ntOpenSizeGuideModal(){
  var bd=document.getElementById('ntSizeGuideModalBd');
  var modal=document.getElementById('ntSizeGuideModal');
  if(!bd||!modal)return;
  bd.style.display='block';
  modal.style.display='flex';
  setTimeout(function(){
    modal.style.transform='translate(-50%,-50%)';
    modal.style.opacity='1';
  },10);

  var body=document.getElementById('ntSizeGuideModalBody');
  if(body.innerHTML.trim())return; // already built

  var sizes=[
    {s:'6"',  label:'Mini',      desc:'Candle holder · gifting',   note:'1–2 short words',       img:''},
    {s:'8"',  label:'Compact',   desc:'Phone width · desk piece',  note:'Up to 8 letters/line',  img:''},
    {s:'9"',  label:'Popular ✦', desc:'Notebook · home office',    note:'Most ordered size',      img:''},
    {s:'10"', label:'Bold',      desc:'A4 paper · shelf',          note:'Up to 11 letters/line', img:''},
    {s:'12"', label:'Statement', desc:'Laptop width · wall',       note:'Long names & quotes',   img:''},
    {s:'14"', label:'Large',     desc:'Art print · feature wall',  note:'Commands any wall',     img:''},
    {s:'16"', label:'Grand',     desc:'Poster · living room',      note:'3–4 line designs',      img:''},
    {s:'18"', label:'Majestic',  desc:'Gallery wall anchor',       note:'Statement centrepiece', img:''},
  ];

  // Use gallery images if available
  var galleryImgs=(window.NUKKAD_CONFIG&&NUKKAD_CONFIG.galleryImages)||[];
  sizes.forEach(function(sz,i){ if(galleryImgs[i]) sz.img=galleryImgs[i]; });

  var html='';

  // Instruction line
  html+='<div style="font-family:\'DM Sans\',sans-serif;font-size:10px;font-weight:600;color:#a07850;margin-bottom:10px;letter-spacing:.04em;text-transform:uppercase;">Tap a size to see in full</div>';

  // Horizontal scroll image carousel
  html+='<div style="display:flex;gap:10px;overflow-x:auto;padding-bottom:10px;margin-bottom:16px;scrollbar-width:none;-webkit-overflow-scrolling:touch;">';
  sizes.forEach(function(sz,i){
    var isPopular=sz.label.indexOf('✦')>=0;
    var hasImg=!!sz.img;
    html+='<div '+(hasImg?'onclick="ntSGOpenLightbox(\''+sz.img+'\',\''+sz.s+'\',\''+sz.desc+'\')" style="flex-shrink:0;width:100px;cursor:pointer;"':'style="flex-shrink:0;width:100px;"')+'>';
    // Image box
    html+='<div style="width:100px;height:100px;border-radius:10px;overflow:hidden;background:#e8e0d8;border:1.5px solid '+(isPopular?'#c47a45':'#e0c9b2')+';margin-bottom:6px;display:flex;align-items:center;justify-content:center;position:relative;">';
    if(hasImg){
      html+='<img src="'+sz.img+'" style="width:100%;height:100%;object-fit:cover;display:block;" loading="lazy">';
    } else {
      // Placeholder with size number
      html+='<span style="font-family:\'Poppins\',sans-serif;font-weight:900;font-size:28px;color:#c8b8a8;">'+sz.s+'</span>';
    }
    if(isPopular) html+='<div style="position:absolute;top:4px;left:4px;background:#c47a45;color:#fff;border-radius:20px;padding:2px 6px;font-size:8px;font-weight:700;font-family:\'DM Sans\',sans-serif;display:none;">Popular</div>';
    html+='</div>';
    // Caption
    html+='<div style="font-family:\'Poppins\',sans-serif;font-weight:900;font-size:13px;color:#3d2b1a;line-height:1;margin-bottom:3px;">'+sz.s+'</div>';
    html+='<div style="font-family:\'DM Sans\',sans-serif;font-size:10px;color:#a07850;line-height:1.4;">'+sz.note+'</div>';
    html+='</div>';
  });
  html+='</div>';

  // Video
  var _sgVideo=(window.NUKKAD_CONFIG&&(NUKKAD_CONFIG.sizeGuideVideoUrl||_sgVideo))||'';
  var _sgThumb=(window.NUKKAD_CONFIG&&(NUKKAD_CONFIG.sizeGuideVideoThumb||NUKKAD_CONFIG.videoThumbnail))||'';
  if(_sgVideo){
    html+='<div style="font-family:\'DM Sans\',sans-serif;font-size:10px;font-weight:600;color:#a07850;margin-bottom:8px;letter-spacing:.04em;text-transform:uppercase;">See in real homes</div>';
    html+='<div style="background:#1e1408;border-radius:12px;overflow:hidden;aspect-ratio:16/9;cursor:pointer;position:relative;" onclick="this.innerHTML=\'<iframe src=\\\''+_sgVideo+'?autoplay=1\\\' width=\\\'100%\\\' height=\\\'100%\\\' frameborder=\\\'0\\\' allowfullscreen style=\\\'position:absolute;inset:0;display:block;\\\'></iframe>\';this.style.cursor=\'default\';">'
      +'<img src="'+(_sgThumb)+'" style="width:100%;height:100%;object-fit:cover;opacity:0.75;display:block;" loading="lazy">'
      +'<div style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;">'
      +'<div style="width:44px;height:44px;background:rgba(255,255,255,0.92);border-radius:50%;display:flex;align-items:center;justify-content:center;"><svg width="14" height="14" viewBox="0 0 24 24" fill="#3d2b1a"><path d="M8 5v14l11-7z"/></svg></div>'
      +'<div style="font-family:\'DM Sans\',sans-serif;font-size:11px;font-weight:700;color:#fff;">Watch · sizes in real homes</div>'
      +'</div></div>';
  }

  body.innerHTML=html;
}

function ntCloseSizeGuideModal(){
  var modal=document.getElementById('ntSizeGuideModal');
  var bd=document.getElementById('ntSizeGuideModalBd');
  if(modal){modal.style.opacity='0';modal.style.transform='translate(-50%,-60%)';}
  setTimeout(function(){
    if(modal)modal.style.display='none';
    if(bd)bd.style.display='none';
  },260);
}

function ntSGOpenLightbox(src,size,desc){
  var lb=document.getElementById('ntSGLightbox');
  if(!lb){
    lb=document.createElement('div');
    lb.id='ntSGLightbox';
    lb.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:900;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;';
    lb.onclick=function(e){if(e.target===lb||e.target===lb.querySelector('img'))lb.style.display='none';};
    var img=document.createElement('img');
    img.id='ntSGLightboxImg';
    img.style.cssText='max-width:88vw;max-height:72vh;object-fit:contain;border-radius:10px;';
    var cap=document.createElement('div');
    cap.id='ntSGLightboxCap';
    cap.style.cssText='text-align:center;';
    var closeBtn=document.createElement('button');
    closeBtn.textContent='✕';
    closeBtn.style.cssText='position:absolute;top:16px;right:16px;background:rgba(255,255,255,0.15);border:none;color:#fff;border-radius:50%;width:32px;height:32px;font-size:15px;cursor:pointer;';
    closeBtn.onclick=function(){lb.style.display='none';};
    lb.appendChild(img);
    lb.appendChild(cap);
    lb.appendChild(closeBtn);
    document.body.appendChild(lb);
  }
  if(src){
    document.getElementById('ntSGLightboxImg').src=src;
    document.getElementById('ntSGLightboxImg').style.display='block';
  } else {
    document.getElementById('ntSGLightboxImg').style.display='none';
  }
  document.getElementById('ntSGLightboxCap').innerHTML=size
    ?'<div style="font-family:\'Poppins\',sans-serif;font-weight:900;font-size:18px;color:#fff;">'+size+'</div>'
     +'<div style="font-family:\'DM Sans\',sans-serif;font-size:12px;color:rgba(255,255,255,0.7);margin-top:4px;">'+desc+'</div>':'' ;
  lb.style.display='flex';
}


function ntScrollToFind(){
  var el=document.querySelector(NUKKAD_CONFIG.findQuoteClass||'.nt-ig-wrap');
  if(el){el.scrollIntoView({behavior:'smooth',block:'start'});}
  else if(NUKKAD_CONFIG.findQuoteUrl){window.location.href=NUKKAD_CONFIG.findQuoteUrl;}
}
function ntOpenBrandLogo(){
  window.location.href = NUKKAD_CONFIG.brandLogoUrl || '/pages/brand-logo';
}
function ntOpenCartFromBar(){
  ntCloseSlider();
  var drawer=document.querySelector('cart-drawer');
  if(drawer)drawer.open();
  else window.location.href='/cart';
}

function ntUpdateCartBtn(){
  fetch('/cart.js')
    .then(function(r){return r.json();})
    .then(function(cart){
      var btn=document.getElementById('ntCartBarBtn');
      var count=document.getElementById('ntCartCount');
      // check if any custom order items
      var customItems=(cart.items||[]).filter(function(i){
        return i.handle&&i.handle.includes('custom-order');
      });
      if(btn){
        if(customItems.length>0){
          btn.style.display='flex';
          if(count)count.textContent=cart.item_count;
        } else {
          btn.style.display='none';
        }
      }
    }).catch(function(){});
}

function ntPlayVideoS4(n){
  var url=n===2?(NUKKAD_CONFIG.video2Url||''):(NUKKAD_CONFIG.videoUrl||'');
  if(!url)return;
  // Replace the card content with an inline iframe
  var card=document.getElementById('ntVideoCard'+n+'S4');
  if(!card)return;
  var autoUrl=url+(url.includes('?')?'&':'?')+'autoplay=1';
  card.innerHTML='<iframe src="'+autoUrl+'" width="100%" height="100%" frameborder="0" allowfullscreen style="display:block;position:absolute;inset:0;"></iframe>';
  card.style.cursor='default';
  card.onclick=null;
}
function ntInitVideoReviews(){
  // Helper to normalise YouTube/Vimeo URL to embed
  function toEmbed(url){
    if(!url)return '';
    if(url.includes('watch?v='))url='https://www.youtube.com/embed/'+url.split('watch?v=')[1].split('&')[0];
    if(url.includes('youtu.be/'))url='https://www.youtube.com/embed/'+url.split('youtu.be/')[1].split('?')[0];
    if(url.includes('youtube.com/shorts/'))url='https://www.youtube.com/embed/'+url.split('shorts/')[1].split('?')[0];
    return url;
  }
  function ytThumb(embedUrl){
    // Extract video ID from embed URL and return YouTube thumbnail
    var m=embedUrl.match(/embed\/([^?&/]+)/);
    return m?'https://img.youtube.com/vi/'+m[1]+'/hqdefault.jpg':'';
  }
  var v1=toEmbed(NUKKAD_CONFIG.videoUrl||'');
  var v2=toEmbed(NUKKAD_CONFIG.video2Url||'');
  NUKKAD_CONFIG.videoUrl=v1;
  NUKKAD_CONFIG.video2Url=v2;

  // Show video wrap if at least one video exists
  var wrap=document.getElementById('ntVideoWrap');
  if(wrap&&(v1||v2)){
    wrap.style.display='flex';
    var thumb1=document.getElementById('ntVideoThumb');
    if(thumb1)thumb1.src=NUKKAD_CONFIG.videoThumbnail||ytThumb(v1);
    var title1=document.getElementById('ntVideoTitle');
    if(title1)title1.textContent=NUKKAD_CONFIG.videoTitle||'See how it\'s made';
    var thumb2=document.getElementById('ntVideoThumb2');
    if(thumb2)thumb2.src=NUKKAD_CONFIG.video2Thumbnail||ytThumb(v2);
    var title2=document.getElementById('ntVideoTitle2');
    if(title2)title2.textContent=NUKKAD_CONFIG.video2Title||'How it\'s made';
    // Hide card if no URL
    var card1=document.getElementById('ntVideoCard1');if(card1)card1.style.display=v1?'block':'none';
    var card2=document.getElementById('ntVideoCard2');if(card2)card2.style.display=v2?'block':'none';
  }
  // Personal stage (S4) video cards
  var wrapS4=document.getElementById('ntVideoWrapS4');
  if(wrapS4&&(v1||v2)){
    wrapS4.style.display='block';
    var c1s4=document.getElementById('ntVideoCard1S4');if(c1s4)c1s4.style.display=v1?'block':'none';
    var c2s4=document.getElementById('ntVideoCard2S4');if(c2s4)c2s4.style.display=v2?'block':'none';
    var t1s4=document.getElementById('ntVideoTitle1S4');if(t1s4)t1s4.textContent=NUKKAD_CONFIG.videoTitle||'See how it\'s made';
    var t2s4=document.getElementById('ntVideoTitle2S4');if(t2s4)t2s4.textContent=NUKKAD_CONFIG.video2Title||'How it\'s made';
    var th1s4=document.getElementById('ntVideoThumb1S4');if(th1s4)th1s4.src=NUKKAD_CONFIG.videoThumbnail||ytThumb(v1);
    var th2s4=document.getElementById('ntVideoThumb2S4');if(th2s4)th2s4.src=NUKKAD_CONFIG.video2Thumbnail||ytThumb(v2);
  }
  // Inject artisan section
  ntInitArtisan();
  // Load Judge.me reviews
  ntLoadReviews();
}

function ntPlayVideoV(card,frameId,url){
  if(!url)return;
  var frame=document.getElementById(frameId);
  if(!frame)return;
  // Hide thumbnail overlay
  var overlay=card.querySelector('div[style*="position:absolute"]');
  var thumb=card.querySelector('img');
  if(overlay)overlay.style.display='none';
  if(thumb)thumb.style.display='none';
  frame.src=url+(url.includes('?')?'&':'?')+'autoplay=1';
  frame.style.display='block';
  card.onclick=null;
}

function ntInitArtisan(){
  if(!NUKKAD_CONFIG.artisanCount)return;
  var colors=['#c47a45','#2aac8e','#8aac8e','#1e3a5f','#d4a5a5','#e8c94a','#6b7280','#3d2b1a'];
  ['','S4'].forEach(function(suffix){
    var wrap=document.getElementById('ntArtisan'+suffix);
    if(!wrap)return;
    wrap.style.display='block';
    var countEl=document.getElementById('ntArtisanCount'+suffix);
    var namesEl=document.getElementById('ntArtisanNames'+suffix);
    var quoteEl=document.getElementById('ntArtisanQuote'+suffix);
    var statEl=document.getElementById('ntArtisanStat'+suffix);
    var sinceEl=document.getElementById('ntArtisanSince'+suffix);
    var avatarsEl=document.getElementById('ntArtisanAvatars'+suffix);
    if(countEl)countEl.textContent=NUKKAD_CONFIG.artisanCount||'8 artisan families';
    if(namesEl)namesEl.textContent=NUKKAD_CONFIG.artisanNames||'';
    if(quoteEl)quoteEl.textContent=NUKKAD_CONFIG.artisanQuote||'';
    if(suffix==='S4'){
      // Dark strip needs short stat — extract just the number/short form
      // e.g. "1,50,000+ pieces shipped across India" → "1.5L+"
      var statShort=(NUKKAD_CONFIG.artisanStatShort||'').trim();
      if(!statShort){
        // Auto-shorten: grab digits+symbols before first space
        var m=(NUKKAD_CONFIG.artisanStat||'').match(/^[\d,\.\+]+/);
        statShort=m?m[0]:(NUKKAD_CONFIG.artisanStat||'').split(' ')[0];
      }
      if(statEl)statEl.textContent=statShort;
      // Since: extract just the year "since 2019 ❤" → "2019"
      var sinceShort=(NUKKAD_CONFIG.artisanSince||'').match(/\d{4}/);
      if(sinceEl)sinceEl.textContent=sinceShort?sinceShort[0]:(NUKKAD_CONFIG.artisanSince||'');
    } else {
      if(statEl)statEl.textContent=NUKKAD_CONFIG.artisanStat||'';
      if(sinceEl)sinceEl.textContent=NUKKAD_CONFIG.artisanSince||'';
    }
    if(avatarsEl){
      var imgs=NUKKAD_CONFIG.artisanImages||[];
      var names=(NUKKAD_CONFIG.artisanNames||'').split(',').map(function(n){return n.trim();});
      var total=parseInt((NUKKAD_CONFIG.artisanCount||'8').match(/\d+/)||[8])[0];
      var shown=Math.min(4, imgs.length||names.length||4);
      var extra=total-shown;
      var html='';
      for(var i=0;i<shown;i++){
        var ml=i>0?'margin-left:-8px;':'';
        if(imgs[i]){
          html+='<img src="'+imgs[i].src+'" alt="'+(imgs[i].name||'')+'" style="width:32px;height:32px;border-radius:50%;object-fit:cover;border:2px solid #fff;'+ml+'flex-shrink:0;" loading="lazy">';
        } else {
          var initial=(names[i]||'A')[0].toUpperCase();
          var bg=colors[i%colors.length];
          html+='<div style="width:32px;height:32px;border-radius:50%;background:'+bg+';border:2px solid #fff;'+ml+'flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff;">'+initial+'</div>';
        }
      }
      if(extra>0){
        html+='<div style="width:32px;height:32px;border-radius:50%;background:#e0cdb8;border:2px solid #fff;margin-left:-8px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;color:var(--brown);">+'+extra+'</div>';
      }
      avatarsEl.innerHTML=html;
    }
  });
}

function ntLoadReviews(){
  var dests=['ntReviewsWrap','ntReviewsWrapS4'];
  // Check if already loaded
  if(document.getElementById('ntReviewsWrap').innerHTML.trim())return;

  fetch('https://cozy-dieffenbachia-95eb4b.netlify.app/.netlify/functions/nt-reviews')
    .then(function(r){return r.json();})
    .then(function(data){
      var reviews=data.reviews||[];
      if(!reviews.length)return;
      var html=ntBuildReviewsCarousel(reviews);
      dests.forEach(function(id){
        var el=document.getElementById(id);
        if(el)el.innerHTML=html;
      });
      // Init carousel scroll
      setTimeout(ntInitReviewScroll,100);
    })
    .catch(function(){});
}

function ntBuildReviewsCarousel(reviews){
  var stars=function(n){
    var s='';for(var i=0;i<5;i++)s+='<span style="color:'+(i<n?'#e8a020':'#ddd')+';">★</span>';return s;
  };
  // Only show reviews WITH photos
  var photoReviews=reviews.filter(function(r){return r.photos&&r.photos.length>0;});
  if(!photoReviews.length)return '<div style="display:none;"></div>'; // hide if no photo reviews

  var cards=photoReviews.map(function(r,idx){
    var cardId='ntr-'+idx;
    var photo=r.photos[0];
    var productHtml=r.product?'<div style="font-size:9px;color:var(--orange);font-weight:700;letter-spacing:.04em;text-transform:uppercase;margin-bottom:4px;">'+r.product+'</div>':'';
    var photoHtml=photo
      ?'<img src="'+photo+'" style="width:100%;display:block;border-radius:8px 8px 0 0;object-fit:cover;max-height:160px;" loading="lazy">'
      :'';
    var bodyId='ntrbody-'+idx;
    return '<div style="flex-shrink:0;width:180px;height:340px;background:#fff;border:1px solid var(--border);border-radius:12px;overflow:hidden;display:flex;flex-direction:column;user-select:none;">'
      +photoHtml
      +'<div style="padding:10px;display:flex;flex-direction:column;flex:1;overflow:hidden;">'
      +productHtml
      +'<div style="font-size:11px;line-height:1;margin-bottom:5px;">'+stars(r.rating)+'</div>'
      +'<div id="'+bodyId+'" style="font-size:10px;color:var(--brown);line-height:1.55;overflow:hidden;flex:1;position:relative;">'
      +r.body
      +'</div>'
      +'<div style="font-size:9px;color:var(--muted);font-weight:600;margin-top:6px;line-height:1.4;">'+r.name+'<br>'+r.date+'</div>'
      +'</div>'
      +'</div>';
  }).join('');

  return '<div style="margin-top:16px;">'
    +'<div style="font-size:10px;font-weight:700;color:var(--muted);letter-spacing:.08em;text-transform:uppercase;margin-bottom:10px;">What customers say · 4.9★</div>'
    +'<div class="nt-review-scroll" style="display:flex;gap:10px;overflow-x:auto;-webkit-overflow-scrolling:touch;padding:0 0 8px;cursor:grab;scrollbar-width:none;-ms-overflow-style:none;">'
    +cards
    +'</div>'
    +'</div>';
}


function ntInitReviewScroll(){
  document.querySelectorAll('.nt-review-scroll').forEach(function(el){
    // Hide scrollbar
    el.style.msOverflowStyle='none';
    // Mouse drag scroll
    var isDown=false,startX,scrollLeft;
    el.addEventListener('mousedown',function(e){
      isDown=true;el.style.cursor='grabbing';
      startX=e.pageX-el.offsetLeft;scrollLeft=el.scrollLeft;
    });
    el.addEventListener('mouseleave',function(){isDown=false;el.style.cursor='grab';});
    el.addEventListener('mouseup',function(){isDown=false;el.style.cursor='grab';});
    el.addEventListener('mousemove',function(e){
      if(!isDown)return;e.preventDefault();
      var x=e.pageX-el.offsetLeft;
      el.scrollLeft=scrollLeft-(x-startX)*1.5;
    });
    // Hint scroll on load
    setTimeout(function(){el.scrollTo({left:80,behavior:'smooth'});},1000);
    setTimeout(function(){el.scrollTo({left:0,behavior:'smooth'});},2200);
  });
}

// ── ICON ON LETTER SYSTEM ─────────────────────────────
window.ntLetterIcon = {active:false, letter:'', line:0, charIdx:0, iconSrc:'', iconLabel:''};
var _ntILSelLetter = null, _ntILSelLine = 0, _ntILSelChar = 0, _ntILSelIcon = null;

function ntOpenIconLetter(){
  var allIcons = window.NT_CUSTOM_ICONS||[];
  var icons = allIcons.filter(function(ic){return ic.forLetter;});
  if(!icons.length){
    alert('No icons set for letter picker. In Theme Customiser → Nukkad Customiser, add icon labels to the "Icons available for letter picker" field.');
    return;
  }
  if(!icons.length){
    alert('No icons found. Add icons in Theme Customiser > Nukkad Customiser > Add block > Custom icon');
    return;
  }

  var grid = document.getElementById('ntILIconTiles');
  if(!grid) return;
  grid.innerHTML = '';

  icons.forEach(function(ic){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.style.cssText = 'display:flex;flex-direction:column;align-items:center;gap:3px;padding:6px 4px;border:1.5px solid #e0c9b2;border-radius:10px;background:#fff;cursor:pointer;width:100%;';
    btn.innerHTML = '<img src="'+ic.src+'" style="width:38px;height:38px;object-fit:contain;" alt="'+ic.label+'">'
      +'<span style="font-size:8px;color:#a07850;text-align:center;line-height:1.2;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;">'+ic.label+'</span>';
    btn.addEventListener('click', function(){
      grid.querySelectorAll('button').forEach(function(b){ b.style.borderColor='#e0c9b2'; b.style.background='#fff'; });
      btn.style.borderColor='#c47a45'; btn.style.background='#fff8f3';
      ntCloseIconLetter();
      setTimeout(function(){ ntILShowFloat(ic); }, 300);
    });
    grid.appendChild(btn);
  });

  var removeBtn = document.getElementById('ntILRemoveBtn');
  if(removeBtn) removeBtn.style.display = (window.ntLetterIcon&&window.ntLetterIcon.active)?'block':'none';

  var sheet = document.getElementById('ntIconLetterSheet');
  var bd = document.getElementById('ntIconLetterBackdrop');
  if(sheet){ sheet.style.display='flex'; setTimeout(function(){ sheet.style.transform='translate(-50%,-50%)'; sheet.style.opacity='1'; },10); }
  if(bd) bd.style.display='block';
}

function ntILShowFloat(ic){
  // Simply place the icon on the canvas - no drag, no float overlay
  window.ntLetterIcon = {
    active: true,
    letter: '',
    line: 0,
    charIdx: 0,
    iconSrc: ic.src,
    iconLabel: ic.label
  };
  if(typeof renderSimple === 'function') renderSimple();
  if(typeof renderS4 === 'function') renderS4();
  ntRefreshIconLetterRow();
}


function ntRemoveLetterIcon(){
  window.ntLetterIcon = {active:false, letter:'', line:0, charIdx:0, iconSrc:'', iconLabel:''};
  ntRefreshIconLetterRow();
  if(typeof renderSimple==='function') renderSimple();
  if(typeof renderS4==='function') renderS4();
  ntCloseIconLetter();
}

function ntRefreshIconLetterRow(){
  ['ntILRow999','ntILRowS4'].forEach(function(id){
    var row=document.getElementById(id);
    if(!row) return;
    var sub=row.querySelector('.ntILRowSub');
    var badge=row.querySelector('.ntILRowBadge');
    var title=row.querySelector('.ntILRowTitle');
    if(window.ntLetterIcon&&window.ntLetterIcon.active){
      if(title) title.textContent='Icon on a letter';
      if(sub) sub.textContent='Tap to change icon';
      if(badge){
        badge.innerHTML=(window.ntLetterIcon.iconSrc?'<img src="'+window.ntLetterIcon.iconSrc+'" style="width:20px;height:20px;object-fit:contain;border-radius:4px;">':'')+
          '<span style="font-size:10px;font-weight:700;color:#1a6644;">Selected: '+(window.ntLetterIcon.iconLabel||'Icon')+'</span>';
        badge.style.display='inline-flex';
        badge.style.alignItems='center';
        badge.style.gap='5px';
        badge.style.padding='4px 10px 4px 6px';
      }
    } else {
      if(title) title.textContent='Icon on a letter';
      if(sub) sub.textContent='Crown, star, Om \u2014 sits on top of any letter';
      if(badge) badge.style.display='none';
    }
  });
}

function ntCloseIconLetter(){
  var sheet=document.getElementById('ntIconLetterSheet');
  var bd=document.getElementById('ntIconLetterBackdrop');
  sheet.style.opacity='0';
  sheet.style.transform='translate(-50%,-60%)';
  setTimeout(function(){sheet.style.display='none'; bd.style.display='none';},260);
}

// ── NAV HELPER TEXT — dismiss on first tap ────────────
function ntDismissNavHelper(){
  try{
    if(localStorage.getItem('nt_nav_used'))return;
    localStorage.setItem('nt_nav_used','1');
    var el=document.getElementById('ntNavHelper');
    if(el){el.style.transition='opacity .4s';el.style.opacity='0';setTimeout(function(){el.style.display='none';},400);}
  }catch(e){}
}
// Hide helper immediately if already used
(function(){
  try{
    if(localStorage.getItem('nt_nav_used')){
      var el=document.getElementById('ntNavHelper');
      if(el)el.style.display='none';
    }
  }catch(e){}

// expose to window
window._ntTutInit=_ntTutInit;
window._ntTutToEmbed=_ntTutToEmbed;
window.goToEditorScreen=goToEditorScreen;
window.goToSearchScreen=goToSearchScreen;
window.ntAddToCart=ntAddToCart;
window.ntApplyBottomSection=ntApplyBottomSection;
window.ntApplyConfigTexts=ntApplyConfigTexts;
window.ntAutoSave=ntAutoSave;
window.ntBuildReviewsCarousel=ntBuildReviewsCarousel;
window.ntClearAllDesigns=ntClearAllDesigns;
window.ntCloseIconLetter=ntCloseIconLetter;
window.ntClosePolicy=ntClosePolicy;
window.ntCloseSizeGuideModal=ntCloseSizeGuideModal;
window.ntCloseSlider=ntCloseSlider;
window.ntCollapseEditBar=ntCollapseEditBar;
window.ntCommissionMantra=ntCommissionMantra;
window.ntCommissionPersonal=ntCommissionPersonal;
window.ntCommissionQuote=ntCommissionQuote;
window.ntDeleteDesign=ntDeleteDesign;
window.ntDesignIt=ntDesignIt;
window.ntDismissNavHelper=ntDismissNavHelper;
window.ntEditSaved=ntEditSaved;
window.ntExpandEditBar=ntExpandEditBar;
window.ntFillAndDesign=ntFillAndDesign;
window.ntGetPrice=ntGetPrice;
window.ntGetVariantId=ntGetVariantId;
window.ntILShowFloat=ntILShowFloat;
window.ntInitArtisan=ntInitArtisan;
window.ntInitCarousel=ntInitCarousel;
window.ntInitReviewScroll=ntInitReviewScroll;
window.ntInitVideoReviews=ntInitVideoReviews;
window.ntInjectCartProps=ntInjectCartProps;
window.ntLoadDesigns=ntLoadDesigns;
window.ntLoadReviews=ntLoadReviews;
window.ntOpenBrandLogo=ntOpenBrandLogo;
window.ntOpenCartFromBar=ntOpenCartFromBar;
window.ntOpenIconLetter=ntOpenIconLetter;
window.ntOpenPolicy=ntOpenPolicy;
window.ntOpenSizeGuide=ntOpenSizeGuide;
window.ntOpenSizeGuideModal=ntOpenSizeGuideModal;
window.ntOpenSlider=ntOpenSlider;
window.ntPlayVideoS4=ntPlayVideoS4;
window.ntPlayVideoV=ntPlayVideoV;
window.ntRefreshIconLetterRow=ntRefreshIconLetterRow;
window.ntRefreshSavedDesigns=ntRefreshSavedDesigns;
window.ntRemoveLetterIcon=ntRemoveLetterIcon;
window.ntSGOpenLightbox=ntSGOpenLightbox;
window.ntSaveDesign=ntSaveDesign;
window.ntScalePiece=ntScalePiece;
window.ntScrollToFind=ntScrollToFind;
window.ntShowInputForm=ntShowInputForm;
window.ntShowWelcomeBack=ntShowWelcomeBack;
window.ntToggleFaq=ntToggleFaq;
window.ntTutClose=ntTutClose;
window.ntTutDismiss=ntTutDismiss;
window.ntTutHideBubble=ntTutHideBubble;
window.ntTutMinimise=ntTutMinimise;
window.ntTutOpen=ntTutOpen;
window.ntTutShowBubble=ntTutShowBubble;
window.ntUpdateCartBtn=ntUpdateCartBtn;
window.ntUpdateDesign=ntUpdateDesign;
window.ntUpdatePersonalBtn=ntUpdatePersonalBtn;
window.ntWelcomeEdit=ntWelcomeEdit;
window.ntWelcomeStartFresh=ntWelcomeStartFresh;

})();


// ── TUTORIAL VIDEO BUBBLE ────────────────────────────
var _ntTutDismissed=false,_ntTutMinimised=false,_ntTutEmbed='';
function _ntTutToEmbed(u){
  if(!u)return'';
  if(u.indexOf('watch?v=')>=0)return'https://www.youtube.com/embed/'+u.split('watch?v=')[1].split('&')[0];
  if(u.indexOf('youtu.be/')>=0)return'https://www.youtube.com/embed/'+u.split('youtu.be/')[1].split('?')[0];
  if(u.indexOf('shorts/')>=0)return'https://www.youtube.com/embed/'+u.split('shorts/')[1].split('?')[0];
  return u;
}
function _ntTutInit(){
  var url=(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.tutorialVideoUrl)||'';
  if(!url)return;
  _ntTutEmbed=_ntTutToEmbed(url);
  var thumb=(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.tutorialVideoThumb)||('https://img.youtube.com/vi/'+(_ntTutEmbed.match(/embed\/([^?&/]+)/)||['',''])[1]+'/hqdefault.jpg');
  var label=(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.tutorialVideoLabel)||'How to order';
  // Move elements to body to escape any transform context
  var card=document.getElementById('ntTutCard');
  var ov=document.getElementById('ntTutOverlay');
  var pill=document.getElementById('ntTutBubble');
  if(card&&card.parentNode!==document.body)document.body.appendChild(card);
  if(ov&&ov.parentNode!==document.body)document.body.appendChild(ov);
  if(pill&&pill.parentNode!==document.body)document.body.appendChild(pill);
  var ct=document.getElementById('ntTutCardThumb');if(ct)ct.src=thumb;
  var pt=document.getElementById('ntTutThumb');if(pt)pt.src=thumb;
  var cl=document.getElementById('ntTutCardLbl');if(cl)cl.textContent=label;
  var pl=document.getElementById('ntTutLbl');if(pl)pl.textContent=label;
  var ol=document.getElementById('ntTutOvLbl');if(ol)ol.textContent=label;
}
function ntTutShowBubble(){
  var url=(window.NUKKAD_CONFIG&&window.NUKKAD_CONFIG.tutorialVideoUrl)||'';
  if(!url||_ntTutDismissed)return;
  if(!_ntTutEmbed)_ntTutInit();
  if(!_ntTutEmbed)return;
  var card=document.getElementById('ntTutCard');
  var pill=document.getElementById('ntTutBubble');
  if(_ntTutMinimised){if(pill)pill.style.display='flex';if(card)card.style.display='none';}
  else{if(card)card.style.display='block';if(pill)pill.style.display='none';}
}
function ntTutHideBubble(){
  var c=document.getElementById('ntTutCard');if(c)c.style.display='none';
  var b=document.getElementById('ntTutBubble');if(b)b.style.display='none';
}
function ntTutOpen(){
  if(!_ntTutEmbed)_ntTutInit();
  var ov=document.getElementById('ntTutOverlay');
  var fr=document.getElementById('ntTutFrame');
  if(!ov||!fr||!_ntTutEmbed)return;
  fr.innerHTML='<iframe src="'+_ntTutEmbed+'?autoplay=1&rel=0" frameborder="0" allowfullscreen allow="autoplay; encrypted-media"></iframe>';
  ov.classList.add('open');
}
function ntTutClose(){
  var ov=document.getElementById('ntTutOverlay');
  var fr=document.getElementById('ntTutFrame');
  if(fr)fr.innerHTML='';
  if(ov)ov.classList.remove('open');
}
function ntTutMinimise(){
  _ntTutMinimised=true;
  var c=document.getElementById('ntTutCard');if(c)c.style.display='none';
  var b=document.getElementById('ntTutBubble');if(b)b.style.display='flex';
}
function ntTutDismiss(){
  _ntTutDismissed=true;
  ntTutHideBubble();
}
document.addEventListener('click',function(e){
  var ov=document.getElementById('ntTutOverlay');
  if(ov&&ov.classList.contains('open')&&e.target===ov)ntTutClose();
});
setTimeout(_ntTutInit,500);

// ── FLOATING PRICE BAR ────────────────────────────────
(function(){
  var _observer=null;

  window.ntToggleNote=function(){
    var box=document.getElementById('ntNoteBox');
    var btn=document.getElementById('ntNoteToggle');
    if(!box||!btn)return;
    var open=box.style.display==='none';
    box.style.display=open?'block':'none';
    btn.textContent=open?'✕ Remove note':'+ Add a note for the artisan';
    btn.style.color=open?'var(--brown)':'var(--muted)';
    if(open)setTimeout(function(){var t=document.getElementById('ntNoteText');if(t)t.focus();},50);
  };

  window.ntFloatBarUpdate=function(totalPrice,breakdown){
    var bar=document.getElementById('ntFloatBar');
    if(!bar)return;
    // Move to body once so position:fixed works
    if(bar.parentNode!==document.body){
      document.body.appendChild(bar);
      // Add resize listener once
      if(!bar._resizeBound){
        bar._resizeBound=true;
        function _ntSyncBar(){
          var _sl=document.getElementById('ntSl');
          var _b=document.getElementById('ntFloatBar');
          if(_sl&&_b){
            var _sr=_sl.getBoundingClientRect();
            // Only constrain on desktop (slider not full width)
            if(_sr.left>10){
              _b.style.left=_sr.left+'px';
              _b.style.right=(window.innerWidth-_sr.right)+'px';
              _b.style.width=_sr.width+'px';
            } else {
              // Mobile: full width
              _b.style.left='0';
              _b.style.right='0';
              _b.style.width='100%';
            }
            _b.style.maxWidth='none';
          }
        }
        window.addEventListener('resize',_ntSyncBar);
        window._ntSyncBar=_ntSyncBar;
      }
    }
    // Sync position every time bar updates
    if(window._ntSyncBar)window._ntSyncBar();
    var tot=document.getElementById('ntFloatBarTotal');
    var bd=document.getElementById('ntFloatBarBreakdown');
    if(tot)tot.textContent='₹'+totalPrice.toLocaleString('en-IN');
    if(bd)bd.innerHTML=breakdown;
    // Show/hide based on whether s4Btn is visible
    var s4btn=document.getElementById('s4Btn');
    if(s4btn){
      var rect=s4btn.getBoundingClientRect();
      var inView=rect.top>=0&&rect.bottom<=(window.innerHeight||document.documentElement.clientHeight);
      bar.style.display=inView?'none':'flex';
    } else {
      bar.style.display='flex';
    }
    // Setup scroll listener once
    if(!bar._scrollBound){
      bar._scrollBound=true;
      // Find the actual scroll container (.nt-editor-body)
      var scroller=document.querySelector('.nt-editor-body');
      function _ntCheckFloatBar(){
        var s4b=document.getElementById('s4Btn');
        var b=document.getElementById('ntFloatBar');
        if(!s4b||!b)return;
        var r=s4b.getBoundingClientRect();
        var vh=window.innerHeight||document.documentElement.clientHeight;
        // Only show float bar when s4Btn is above viewport (user hasn't scrolled to it yet)
        // Hide when s4Btn is visible OR when user has scrolled past it (below viewport)
        var aboveViewport=r.bottom<0;
        var inView=r.top>=0&&r.bottom<=vh;
        b.style.display=(aboveViewport||inView)?'none':'flex';
      }
      if(scroller){
        scroller.addEventListener('scroll',_ntCheckFloatBar,{passive:true});
      }
    }
  };

  window.ntFloatBarHide=function(){
    var bar=document.getElementById('ntFloatBar');
    if(bar)bar.style.display='none';
    if(_observer){_observer.disconnect();_observer=null;}
    var b=document.getElementById('ntFloatBar');
    if(b)b._observing=false;
  };

// expose to window
window._ntTutInit=_ntTutInit;
window._ntTutToEmbed=_ntTutToEmbed;
window.goToEditorScreen=goToEditorScreen;
window.goToSearchScreen=goToSearchScreen;
window.ntAddToCart=ntAddToCart;
window.ntApplyBottomSection=ntApplyBottomSection;
window.ntApplyConfigTexts=ntApplyConfigTexts;
window.ntAutoSave=ntAutoSave;
window.ntBuildReviewsCarousel=ntBuildReviewsCarousel;
window.ntClearAllDesigns=ntClearAllDesigns;
window.ntCloseIconLetter=ntCloseIconLetter;
window.ntClosePolicy=ntClosePolicy;
window.ntCloseSizeGuideModal=ntCloseSizeGuideModal;
window.ntCloseSlider=ntCloseSlider;
window.ntCollapseEditBar=ntCollapseEditBar;
window.ntCommissionMantra=ntCommissionMantra;
window.ntCommissionPersonal=ntCommissionPersonal;
window.ntCommissionQuote=ntCommissionQuote;
window.ntDeleteDesign=ntDeleteDesign;
window.ntDesignIt=ntDesignIt;
window.ntDismissNavHelper=ntDismissNavHelper;
window.ntEditSaved=ntEditSaved;
window.ntExpandEditBar=ntExpandEditBar;
window.ntFillAndDesign=ntFillAndDesign;
window.ntGetPrice=ntGetPrice;
window.ntGetVariantId=ntGetVariantId;
window.ntILShowFloat=ntILShowFloat;
window.ntInitArtisan=ntInitArtisan;
window.ntInitCarousel=ntInitCarousel;
window.ntInitReviewScroll=ntInitReviewScroll;
window.ntInitVideoReviews=ntInitVideoReviews;
window.ntInjectCartProps=ntInjectCartProps;
window.ntLoadDesigns=ntLoadDesigns;
window.ntLoadReviews=ntLoadReviews;
window.ntOpenBrandLogo=ntOpenBrandLogo;
window.ntOpenCartFromBar=ntOpenCartFromBar;
window.ntOpenIconLetter=ntOpenIconLetter;
window.ntOpenPolicy=ntOpenPolicy;
window.ntOpenSizeGuide=ntOpenSizeGuide;
window.ntOpenSizeGuideModal=ntOpenSizeGuideModal;
window.ntOpenSlider=ntOpenSlider;
window.ntPlayVideoS4=ntPlayVideoS4;
window.ntPlayVideoV=ntPlayVideoV;
window.ntRefreshIconLetterRow=ntRefreshIconLetterRow;
window.ntRefreshSavedDesigns=ntRefreshSavedDesigns;
window.ntRemoveLetterIcon=ntRemoveLetterIcon;
window.ntSGOpenLightbox=ntSGOpenLightbox;
window.ntSaveDesign=ntSaveDesign;
window.ntScalePiece=ntScalePiece;
window.ntScrollToFind=ntScrollToFind;
window.ntShowInputForm=ntShowInputForm;
window.ntShowWelcomeBack=ntShowWelcomeBack;
window.ntToggleFaq=ntToggleFaq;
window.ntTutClose=ntTutClose;
window.ntTutDismiss=ntTutDismiss;
window.ntTutHideBubble=ntTutHideBubble;
window.ntTutMinimise=ntTutMinimise;
window.ntTutOpen=ntTutOpen;
window.ntTutShowBubble=ntTutShowBubble;
window.ntUpdateCartBtn=ntUpdateCartBtn;
window.ntUpdateDesign=ntUpdateDesign;
window.ntUpdatePersonalBtn=ntUpdatePersonalBtn;
window.ntWelcomeEdit=ntWelcomeEdit;
window.ntWelcomeStartFresh=ntWelcomeStartFresh;

})();

function ntApplyConfigTexts(){
  var t=(window.NUKKAD_CONFIG&&NUKKAD_CONFIG.txt)||{};
  function set(id,val){var el=document.getElementById(id);if(el&&val)el.textContent=val;}
  function setHTML(id,val){var el=document.getElementById(id);if(el&&val)el.innerHTML=val;}

  // AI label — keep span for GO BIGGER styling
  var aiEl=document.getElementById('aiLabelTextS4');
  if(aiEl&&t.aiSuggested){
    var bigger=t.goBigger||'GO BIGGER for more impact';
    aiEl.innerHTML='✦ '+t.aiSuggested+' · <span style="letter-spacing:.04em;color:#a8ffc4;">'+bigger+'</span>';
  }

  set('ntSgRowTitle',  t.sizeGuideTitle);
  set('ntSgRowSub',    t.sizeGuideSub);
  set('ntSgRowView',   t.sizeGuideView);
  set('ntDesignerTitle', t.designerTitle);
  set('ntDesignerSub',   t.designerSub);
  set('ntDesignerPrice', t.designerPrice);
  set('ntCommSub',     t.commSub);
  set('ntILRowTitle',  t.iconLetterTitle);
  set('ntSplitTipSub', t.splitTipSub);

  // Designer call visibility — false = hide, anything else = show
  var showDc=(window.NUKKAD_CONFIG&&NUKKAD_CONFIG.showDesignerCall===false)?false:true;
  ['mantraDesignerToggle','renderDesignerToggle','designerToggle'].forEach(function(id){
    var el=document.getElementById(id);if(el)el.style.display=showDc?'':'none';
  });
  // Custom cart message
  var msgEnabled=window.NUKKAD_CONFIG&&NUKKAD_CONFIG.cartMsgEnabled;
  var msgText=window.NUKKAD_CONFIG&&NUKKAD_CONFIG.cartMsg;
  ['ntCartMsg999','ntCartMsgS4','ntCartMsgMantra'].forEach(function(id){
    var el=document.getElementById(id);
    if(!el)return;
    if(msgEnabled&&msgText){el.innerHTML=msgText;el.style.display='block';}
    else{el.style.display='none';}
  });
  // Commission button label — updates both quote + personal buttons
  if(t.commLabel){
    var _s4=document.getElementById('s4Btn');
    var _cb=document.getElementById('commBtn');
    var _mb=document.getElementById('mantraCommBtn');
    // Preserve the price suffix if present
    function applyLabel(btn, label){
      if(!btn) return;
      var cur=btn.textContent;
      var priceMatch=cur.match(/(·\s*₹[\d,]+)/);
      btn.textContent=priceMatch?label+' '+priceMatch[1]:label;
    }
    applyLabel(_s4, t.commLabel);
    applyLabel(_cb, t.commLabel);
    if(_mb) _mb.textContent=t.commLabel;
  }
  // Commission trust line — keep bold on first part
  if(t.commTrust){
    var parts=t.commTrust.split('·');
    var el=document.getElementById('ntCommTrust');
    if(el) el.innerHTML='<b>'+parts[0].trim()+'</b>'+(parts.length>1?' · '+parts.slice(1).join('·'):'');
  }
}
// Run after config is applied
setTimeout(ntApplyConfigTexts, 400);



// Strip emoji live as user types in main input
(function(){
  var inp=document.getElementById('ntSlInp');
  if(!inp)return;
  inp.addEventListener('input',function(){
    var pos=this.selectionStart;
    var cleaned=typeof stripEmoji==='function'?stripEmoji(this.value):this.value;
    if(cleaned!==this.value){this.value=cleaned;try{this.setSelectionRange(Math.min(pos,cleaned.length),Math.min(pos,cleaned.length));}catch(e){}}
  });

// expose to window
window._ntTutInit=_ntTutInit;
window._ntTutToEmbed=_ntTutToEmbed;
window.goToEditorScreen=goToEditorScreen;
window.goToSearchScreen=goToSearchScreen;
window.ntAddToCart=ntAddToCart;
window.ntApplyBottomSection=ntApplyBottomSection;
window.ntApplyConfigTexts=ntApplyConfigTexts;
window.ntAutoSave=ntAutoSave;
window.ntBuildReviewsCarousel=ntBuildReviewsCarousel;
window.ntClearAllDesigns=ntClearAllDesigns;
window.ntCloseIconLetter=ntCloseIconLetter;
window.ntClosePolicy=ntClosePolicy;
window.ntCloseSizeGuideModal=ntCloseSizeGuideModal;
window.ntCloseSlider=ntCloseSlider;
window.ntCollapseEditBar=ntCollapseEditBar;
window.ntCommissionMantra=ntCommissionMantra;
window.ntCommissionPersonal=ntCommissionPersonal;
window.ntCommissionQuote=ntCommissionQuote;
window.ntDeleteDesign=ntDeleteDesign;
window.ntDesignIt=ntDesignIt;
window.ntDismissNavHelper=ntDismissNavHelper;
window.ntEditSaved=ntEditSaved;
window.ntExpandEditBar=ntExpandEditBar;
window.ntFillAndDesign=ntFillAndDesign;
window.ntGetPrice=ntGetPrice;
window.ntGetVariantId=ntGetVariantId;
window.ntILShowFloat=ntILShowFloat;
window.ntInitArtisan=ntInitArtisan;
window.ntInitCarousel=ntInitCarousel;
window.ntInitReviewScroll=ntInitReviewScroll;
window.ntInitVideoReviews=ntInitVideoReviews;
window.ntInjectCartProps=ntInjectCartProps;
window.ntLoadDesigns=ntLoadDesigns;
window.ntLoadReviews=ntLoadReviews;
window.ntOpenBrandLogo=ntOpenBrandLogo;
window.ntOpenCartFromBar=ntOpenCartFromBar;
window.ntOpenIconLetter=ntOpenIconLetter;
window.ntOpenPolicy=ntOpenPolicy;
window.ntOpenSizeGuide=ntOpenSizeGuide;
window.ntOpenSizeGuideModal=ntOpenSizeGuideModal;
window.ntOpenSlider=ntOpenSlider;
window.ntPlayVideoS4=ntPlayVideoS4;
window.ntPlayVideoV=ntPlayVideoV;
window.ntRefreshIconLetterRow=ntRefreshIconLetterRow;
window.ntRefreshSavedDesigns=ntRefreshSavedDesigns;
window.ntRemoveLetterIcon=ntRemoveLetterIcon;
window.ntSGOpenLightbox=ntSGOpenLightbox;
window.ntSaveDesign=ntSaveDesign;
window.ntScalePiece=ntScalePiece;
window.ntScrollToFind=ntScrollToFind;
window.ntShowInputForm=ntShowInputForm;
window.ntShowWelcomeBack=ntShowWelcomeBack;
window.ntToggleFaq=ntToggleFaq;
window.ntTutClose=ntTutClose;
window.ntTutDismiss=ntTutDismiss;
window.ntTutHideBubble=ntTutHideBubble;
window.ntTutMinimise=ntTutMinimise;
window.ntTutOpen=ntTutOpen;
window.ntTutShowBubble=ntTutShowBubble;
window.ntUpdateCartBtn=ntUpdateCartBtn;
window.ntUpdateDesign=ntUpdateDesign;
window.ntUpdatePersonalBtn=ntUpdatePersonalBtn;
window.ntWelcomeEdit=ntWelcomeEdit;
window.ntWelcomeStartFresh=ntWelcomeStartFresh;

})();

(function(){var sy=0,sw=false;var h=document.querySelector('.nt-sl-handle');if(h)h.addEventListener('touchstart',function(e){sy=e.touches[0].clientY;sw=true;},{passive:true});document.addEventListener('touchend',function(e){if(sw&&e.changedTouches&&e.changedTouches[0].clientY-sy>80)ntCloseSlider();sw=false;},{passive:true});})();
// ── DELIVERY + FAQ FROM CONFIG ─────────────────────────
function ntApplyBottomSection(){
  var cfg=window.NUKKAD_CONFIG||{};
  // Policies from customiser
  var _pm={ntPolicyDesign:'policyDesign',ntPolicyCancel:'policyCancel',ntPolicyReturns:'policyReturns',ntPolicyDelivery:'policyDelivery',ntPolicySupport:'policySupport'};
  Object.keys(_pm).forEach(function(elId){var el=document.getElementById(elId);var val=cfg[_pm[elId]];if(el&&val)el.innerHTML=val;});
  var dd=document.getElementById('ntDeliveryDays');
  if(dd&&cfg.deliveryDays)dd.textContent=cfg.deliveryDays;
  var ds=document.getElementById('ntDeliverySub');
  if(ds&&cfg.deliverySub)ds.textContent=cfg.deliverySub;
  var faqWrap=document.getElementById('ntFaqWrap');
  var faqItems=document.getElementById('ntFaqItems');
  var faqs=(cfg.faq||[]).filter(function(f){return f&&f.q&&f.a;});
  if(faqWrap&&faqItems&&faqs.length){
    faqWrap.style.display='block';
    faqItems.innerHTML=faqs.map(function(f,i){
      return '<div style="background:#fff;border:1.5px solid #e8d5c0;border-radius:12px;margin-bottom:7px;overflow:hidden;">'
        +'<div onclick="ntToggleFaq('+i+')" style="display:flex;align-items:center;justify-content:space-between;padding:12px 14px;cursor:pointer;font-family:\'Poppins\',sans-serif;font-weight:700;font-size:11px;color:#3d2b1a;gap:8px;">'
        +f.q+'<span id="ntFaqIcon'+i+'" style="font-size:16px;color:#c47a45;transition:transform .25s;flex-shrink:0;font-weight:300;line-height:1;">+</span></div>'
        +'<div id="ntFaqAns'+i+'" style="max-height:0;overflow:hidden;transition:max-height .3s ease,padding .3s ease;font-size:10px;color:#8c7b6e;line-height:1.65;padding:0 14px;">'+f.a+'</div>'
        +'</div>';
    }).join('');
  }
}
window._ntFaqOpen=-1;
function ntToggleFaq(i){
  var prev=window._ntFaqOpen;
  if(prev>=0&&prev!==i){
    var pa=document.getElementById('ntFaqAns'+prev),pi=document.getElementById('ntFaqIcon'+prev);
    if(pa){pa.style.maxHeight='0';pa.style.padding='0 14px';}
    if(pi)pi.style.transform='';
  }
  var a=document.getElementById('ntFaqAns'+i),ic=document.getElementById('ntFaqIcon'+i);
  var isOpen=(prev===i);
  if(isOpen){if(a){a.style.maxHeight='0';a.style.padding='0 14px';}if(ic)ic.style.transform='';window._ntFaqOpen=-1;}
  else{if(a){a.style.maxHeight='200px';a.style.padding='0 14px 13px';}if(ic)ic.style.transform='rotate(45deg)';window._ntFaqOpen=i;}
}
setTimeout(ntApplyBottomSection,650);


// expose to window
window._ntTutInit=_ntTutInit;
window._ntTutToEmbed=_ntTutToEmbed;
window.goToEditorScreen=goToEditorScreen;
window.goToSearchScreen=goToSearchScreen;
window.ntAddToCart=ntAddToCart;
window.ntApplyBottomSection=ntApplyBottomSection;
window.ntApplyConfigTexts=ntApplyConfigTexts;
window.ntAutoSave=ntAutoSave;
window.ntBuildReviewsCarousel=ntBuildReviewsCarousel;
window.ntClearAllDesigns=ntClearAllDesigns;
window.ntCloseIconLetter=ntCloseIconLetter;
window.ntClosePolicy=ntClosePolicy;
window.ntCloseSizeGuideModal=ntCloseSizeGuideModal;
window.ntCloseSlider=ntCloseSlider;
window.ntCollapseEditBar=ntCollapseEditBar;
window.ntCommissionMantra=ntCommissionMantra;
window.ntCommissionPersonal=ntCommissionPersonal;
window.ntCommissionQuote=ntCommissionQuote;
window.ntDeleteDesign=ntDeleteDesign;
window.ntDesignIt=ntDesignIt;
window.ntDismissNavHelper=ntDismissNavHelper;
window.ntEditSaved=ntEditSaved;
window.ntExpandEditBar=ntExpandEditBar;
window.ntFillAndDesign=ntFillAndDesign;
window.ntGetPrice=ntGetPrice;
window.ntGetVariantId=ntGetVariantId;
window.ntILShowFloat=ntILShowFloat;
window.ntInitArtisan=ntInitArtisan;
window.ntInitCarousel=ntInitCarousel;
window.ntInitReviewScroll=ntInitReviewScroll;
window.ntInitVideoReviews=ntInitVideoReviews;
window.ntInjectCartProps=ntInjectCartProps;
window.ntLoadDesigns=ntLoadDesigns;
window.ntLoadReviews=ntLoadReviews;
window.ntOpenBrandLogo=ntOpenBrandLogo;
window.ntOpenCartFromBar=ntOpenCartFromBar;
window.ntOpenIconLetter=ntOpenIconLetter;
window.ntOpenPolicy=ntOpenPolicy;
window.ntOpenSizeGuide=ntOpenSizeGuide;
window.ntOpenSizeGuideModal=ntOpenSizeGuideModal;
window.ntOpenSlider=ntOpenSlider;
window.ntPlayVideoS4=ntPlayVideoS4;
window.ntPlayVideoV=ntPlayVideoV;
window.ntRefreshIconLetterRow=ntRefreshIconLetterRow;
window.ntRefreshSavedDesigns=ntRefreshSavedDesigns;
window.ntRemoveLetterIcon=ntRemoveLetterIcon;
window.ntSGOpenLightbox=ntSGOpenLightbox;
window.ntSaveDesign=ntSaveDesign;
window.ntScalePiece=ntScalePiece;
window.ntScrollToFind=ntScrollToFind;
window.ntShowInputForm=ntShowInputForm;
window.ntShowWelcomeBack=ntShowWelcomeBack;
window.ntToggleFaq=ntToggleFaq;
window.ntTutClose=ntTutClose;
window.ntTutDismiss=ntTutDismiss;
window.ntTutHideBubble=ntTutHideBubble;
window.ntTutMinimise=ntTutMinimise;
window.ntTutOpen=ntTutOpen;
window.ntTutShowBubble=ntTutShowBubble;
window.ntUpdateCartBtn=ntUpdateCartBtn;
window.ntUpdateDesign=ntUpdateDesign;
window.ntUpdatePersonalBtn=ntUpdatePersonalBtn;
window.ntWelcomeEdit=ntWelcomeEdit;
window.ntWelcomeStartFresh=ntWelcomeStartFresh;

})();